import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiUrl } from '../schema/api-url';
import { AUTH, XTENANT } from 'src/app/constant/constant';
import { BaseServiceGDNN } from './master/base-gdnn.service';
import { APIServiceGDNN } from './master/api-gdnn.service';

@Injectable({
    providedIn: 'root'
})
export class GdnnService extends BaseServiceGDNN {

    goiSSO(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.VACCEIN.goiSSO, requestBody);
    }

    getReportTuyenSinh(tinhID, nam): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': 'report'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.LIST_TUYEN_SINH + "?tinhID=" + tinhID + "&nam=" + nam, requestOptions);

        // return super.get(apiUrl.GDNN.BAOCAO.LIST_TUYEN_SINH, {tinhID: tinhID, nam: nam});
    }

    // getReportThietBi(tinhID, nam): Observable<any> {
    //     return super.get(apiUrl.GDNN.BAOCAO.LIST_THIET_BI, {tinhID: tinhID, nam: nam});
    // }

    // getReportDaoTaoNghe(tinhID, nam): Observable<any> {
    //     return super.get(apiUrl.GDNN.BAOCAO.LIST_DAO_TAO_NGHE, {tinhID: tinhID, nam: nam});
    // }

    // getReportBoiDuong(tinhID, nam): Observable<any> {
    //     return super.get(apiUrl.GDNN.BAOCAO.LIST_BOI_DUONG, {tinhID: tinhID, nam: nam});
    // }

    getListKyTiem(): Observable<any> {
        return super.get(apiUrl.GDNN.VACCEIN.GET_LIST);
    }

    deleteKyTiemVaccein(kyTiemVaccineID): Observable<any> {
        return super.delete(apiUrl.GDNN.VACCEIN.DELETE, { kyTiemVaccineID: kyTiemVaccineID });
    }

    themKyTiemVaccein(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.VACCEIN.ADD, requestBody);
    }

    capNhatKyTiemVaccein(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.VACCEIN.UPDATE, requestBody);
    }

    listTiemVaccine() {
        return super.get(apiUrl.GDNN.VACCEIN.LIST_PHAN_BO);
    }

    listDaTiem(kyTiemID, trangThai) {
        return super.get(apiUrl.GDNN.VACCEIN.LIST_TIEM, { kyTiemID: kyTiemID, trangThai: trangThai });
    }

    phanBoLanMot(requestBody) {
        return super.post(apiUrl.GDNN.VACCEIN.PHAN_BO_LAN_MOT, requestBody);
    }

    phanBoLanHai(requestBody) {
        return super.post(apiUrl.GDNN.VACCEIN.PHAN_BO_LAN_HAI, requestBody);
    }

    constructor(
        private _apiService: APIServiceGDNN,
        private http: HttpClient,
    ) {
        super(_apiService);
    }

    getUser(): Observable<any> {
        return super.get(apiUrl.GDNN.DETAIL_USER.USER);
    }

    // getListCategory(): Observable<any> {
    //     return super.get(apiUrl.GDNN.SINH_VIEN_CAO_DANG.CATEGORY_LIST);
    // }
    /**
     * @author psdung
     * @method GET
     * @param
     * @description Danh mục cán bộ
     */
    getDanhMucCanBo(): Observable<any> {
        return super.get(apiUrl.GDNN.CAN_BO_QUAN_LY.CATEGORY_LIST);
    }
    /**
     * @author psdung
     * @method GET
     * @param
     * @description Danh mục cơ sở đào tạo
     */
    // getDanhMucCoSoDT(): Observable<any> {
    //     return super.get(apiUrl.GDNN.CHUONG_TRINH.CATEGORY_LIST);
    // }
    /**
     * @author psdung
     * @method POST
     * @param requestBody
     * @description Thêm mới cán bộ
     */
    addCanBo(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.CAN_BO_QUAN_LY.THEM_CANBO, requestBody);
    }

    // capNhatCanBo(requestBody): Observable<any> {
    //     return super.put(apiUrl.GDNN.CAN_BO_QUAN_LY.CAPNHAT_CANBO, requestBody);
    // }

    getListCanBo(obj): Observable<any> {
        return super.get(apiUrl.GDNN.CAN_BO_QUAN_LY.CANBO_LIST, obj );
    }

    getListHocVien(dangKyKtx, lopKyHieu, ngaySinh, maHocVien, tenHocVien, page, size): Observable<any> {
        return super.get(apiUrl.GDNN.HOC_VIEN.LIST_HOC_VIEN, { dangKyKtx: dangKyKtx, lopKyHieu: lopKyHieu, ngaySinh: ngaySinh, maHocVien: maHocVien, tenHocVien: tenHocVien, page: page, size: size });
    }
    getChiTietHocVien(hocVienID): Observable<any> {
        return super.get(apiUrl.GDNN.HOC_VIEN.HOC_VIEN_DETAIL, { hocVienID: hocVienID });
    }

    deleteThongTinCanBo(requestBody): Observable<any> {
        return super.delete(apiUrl.GDNN.CAN_BO_QUAN_LY.XOA_CANBO, requestBody);
    }

    capNhatMaCanBo(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.CAN_BO_QUAN_LY.UPDATE_MA_CAN_BO, requestBody);
    }

    // deleteCanBo(): Observable<any> {
    // return this.http.get<any>(apiUrl.GDNN.CAN_BO_QUAN_LY.XOA_CANBO, requestBody, { headers: this.getHeader() });
    //   }

    // addQuaTrinhCongTac(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.CAN_BO_QUAN_LY.THEM_QUATRINHCONGTAC, requestBody);
    // }

    capNhatAnh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.CAN_BO_QUAN_LY.CAP_NHAT_ANH, requestBody);
    }
    xacNhan(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.CAN_BO_QUAN_LY.XAC_NHAN, requestBody);
    }
    tuChoi(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.CAN_BO_QUAN_LY.TU_CHOI, requestBody);
    }
    chuyenCongTac(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.CAN_BO_QUAN_LY.CHUYEN_CONG_TAC, requestBody);
    }
    getCanBoID(canBoNhaGiaoID): Observable<any> {
        return super.get(apiUrl.GDNN.CAN_BO_QUAN_LY.GET_CAN_BO_ID, { canBoNhaGiaoID: canBoNhaGiaoID });
    }
    getCapNhatCanBo(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.CAN_BO_QUAN_LY.CAP_NHAT_CAN_BO, requestBody);
    }

    getAnhDaiDien(fileID): Observable<any> {
        // return super.get(apiUrl.GDNN.CAN_BO_QUAN_LY.GET_ANH_DAI_DIEN + fileID);
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return this.http.get(apiUrl.GDNN.CAN_BO_QUAN_LY.GET_ANH_DAI_DIEN + fileID, requestOptions);
    }

    downloadFile(fileID, fileName): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return super.downloadFile(apiUrl.GDNN.CAN_BO_QUAN_LY.GET_ANH_DAI_DIEN + fileID, fileName);
    }

    capNhatAnhDaiDien(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.CAN_BO_QUAN_LY.CAP_NHAT_ANH, requestBody);
    }

    upload(data, uuidUser) {
        return super.post(apiUrl.GDNN.CAN_BO_QUAN_LY.UPLOAD_ANH_DAI_DIEN + "?createdBy=" + uuidUser, data);
    }

    

    // capNhatQuaTrinhCongTac(requestBody): Observable<any> {
    //     return super.put(apiUrl.GDNN.CAN_BO_QUAN_LY.CAPNHAT_QUATRINHCONGTAC, requestBody);
    // }
    // getListQuaTrinhCongTac(data): Observable<any> {
    //     return super.post(apiUrl.GDNN.CAN_BO_QUAN_LY.QUATRINHCONGTAC_LIST, data);
    // }

    // deleteQuaTrinhCongTac(canBoCongTacID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.CAN_BO_QUAN_LY.XOA_QUATRINHCONGTAC, { canBoCongTacID: canBoCongTacID });
    // }

    // addQuanLyNN(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.CAN_BO_QUAN_LY.THEM_QUANLYNHANUOC, requestBody);
    // }
    //Qua trinh cong tac
    capNhatQuaTrinhCongTac(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.QUA_TRINH_CONG_TAC.UPDATE, requestBody);
    }
    getListQuaTrinhCongTac(canBoID): Observable<any> {
        return super.get(apiUrl.GDNN.QUA_TRINH_CONG_TAC.GET_LIST, { canBoID: canBoID });
    }

    deleteQuaTrinhcongTac(congTacID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.QUA_TRINH_CONG_TAC.DELETE, { congTacID: congTacID, updatedBy: updatedBy });
    }

    khoiPhucQTCT(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.QUA_TRINH_CONG_TAC.KHOI_PHUC, requestBody);
    }

    addQuaTrinhCongTac(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.QUA_TRINH_CONG_TAC.CREATE, requestBody);
    }

    //Trình độ chuyên môn
    capNhatTrinhDoChuyenMon(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TRINH_DO_CHUYEN_MON.UPDATE, requestBody);
    }
    getListTrinhDoChuyenMon(canBoID): Observable<any> {
        return super.get(apiUrl.GDNN.TRINH_DO_CHUYEN_MON.GET_LIST, { canBoID: canBoID });
    }

    searchTrinhDoChuyenMon(canBoID, bacChuyenMon): Observable<any> {
        return super.get(apiUrl.GDNN.TRINH_DO_CHUYEN_MON.GET_LIST, { canBoID: canBoID, bacChuyenMon: bacChuyenMon });
    }

    deleteTrinhDoChuyenMon(chuyenMonID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.TRINH_DO_CHUYEN_MON.DELETE, { chuyenMonID: chuyenMonID, updatedBy: updatedBy });
    }

    addTrinhDoChuyenMon(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.TRINH_DO_CHUYEN_MON.CREATE, requestBody);
    }

    thongKeChuyenMon(coSoDaoTaoID): Observable<any> {
        return super.get(apiUrl.GDNN.TRINH_DO_CHUYEN_MON.THONG_KE, { csdtID: coSoDaoTaoID });
    }

    khoiPhucTrinhDoCM(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TRINH_DO_CHUYEN_MON.khoiPhuc, requestBody);
    }
    //trình độ ngoại ngữ
    capNhatTrinhDoNgoaiNgu(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TRINH_DO_NGOAI_NGU.UPDATE, requestBody);
    }
    getListTrinhDoNgoaiNgu(canBoID): Observable<any> {
        return super.get(apiUrl.GDNN.TRINH_DO_NGOAI_NGU.GET_LIST, { canBoID: canBoID });
    }

    deleteTrinhDoNgoaiNgu(chuyenMonID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.TRINH_DO_NGOAI_NGU.DELETE, { trinhDoNgoaiNguID: chuyenMonID, updatedBy: updatedBy });
    }

    addTrinhDoNgoaiNgu(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.TRINH_DO_NGOAI_NGU.CREATE, requestBody);
    }
    thongKeTrinhDoNgoaiNgu(coSoDaoTaoID): Observable<any> {
        return super.get(apiUrl.GDNN.TRINH_DO_NGOAI_NGU.THONG_KE, { csdtID: coSoDaoTaoID });
    }
    //trình độ tin học
    capNhatTrinhDoTinHoc(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TRINH_DO_TIN_HOC.UPDATE, requestBody);
    }
    getListTrinhDoTinHoc(canBoID): Observable<any> {
        return super.get(apiUrl.GDNN.TRINH_DO_TIN_HOC.GET_LIST, { canBoID: canBoID });
    }

    deleteTrinhDoTinHoc(tinHocID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.TRINH_DO_TIN_HOC.DELETE, { trinhDoTinHocID: tinHocID, updatedBy: updatedBy });
    }

    addTrinhDoTinHoc(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.TRINH_DO_TIN_HOC.CREATE, requestBody);
    }
    thongKeTinHoc(coSoDaoTaoID): Observable<any> {
        return super.get(apiUrl.GDNN.TRINH_DO_TIN_HOC.THONG_KE, { csdtID: coSoDaoTaoID });
    }
    //trình độ chính trị
    capNhatTrinhDoChinhTri(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TRINH_DO_CHINH_TRI.UPDATE, requestBody);
    }
    getListTrinhDoChinhTri(canBoID): Observable<any> {
        return super.get(apiUrl.GDNN.TRINH_DO_CHINH_TRI.GET_LIST, { canBoID: canBoID });
    }

    deleteTrinhDoChinhTri(trinhDoChinhTriID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.TRINH_DO_CHINH_TRI.DELETE, { chuyenMonID: trinhDoChinhTriID, updatedBy: updatedBy });
    }

    addTrinhDoChinhTri(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.TRINH_DO_CHINH_TRI.CREATE, requestBody);
    }
    thongKeChinhTri(coSoDaoTaoID): Observable<any> {
        return super.get(apiUrl.GDNN.TRINH_DO_CHINH_TRI.THONG_KE, { csdtID: coSoDaoTaoID });
    }

    uploadFileImportQuaTrinhCT(obj, canBoID): Observable<any> {
        return super.post(apiUrl.GDNN.QUA_TRINH_CONG_TAC.import + "?canBoID=" + canBoID , obj);
    }

    xuatFileImportQuaTrinhCT(): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.QUA_TRINH_CONG_TAC.mauImport, "File mẫu import quá trình công tac.xlsx", {});
    }

    xuatFileImportTrinhDoCM(): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.TRINH_DO_CHUYEN_MON.mauImport, "File mẫu import trình độ chuyên môn.xlsx", {});
    }

    uploadFileImportTrinhDoChuyenMon(obj): Observable<any> {
        return super.post(apiUrl.GDNN.TRINH_DO_CHUYEN_MON.import + "?canBoID=" + obj.canBoID, obj);
    }


    // addNghiepVuSP(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.CAN_BO_QUAN_LY.THEM_NGHIEPVUSUPHAM, requestBody);
    // }
    // addKyNangNghe(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.CAN_BO_QUAN_LY.THEM_KYNGANGNGHE, requestBody);
    // }
    // addLyLuanCT(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.CAN_BO_QUAN_LY.THEM_LYLUANCHINHTRI, requestBody);
    // }
    // getTimeLineCanBo(officerID): Observable<any> {
    //     return super.get(apiUrl.GDNN.CAN_BO_QUAN_LY.TIMELINECANBO_LIST, { officerID: officerID });
    // }

    // deleteNghiepVuSP(nvspID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.CAN_BO_QUAN_LY.XOA_NGHIEPVUSUPHAM, { nvspID: nvspID });
    // }

    // deleteKyNangNghe(knnID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.CAN_BO_QUAN_LY.XOA_KYNANGNGHE, { knnID: knnID });
    // }

    // deleteLyLuanCT(llctID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.CAN_BO_QUAN_LY.XOA_LYLUANCHINHTRI, { llctID: llctID });
    // }

    // deleteQuanLyNN(qlnn): Observable<any> {
    //     return super.delete(apiUrl.GDNN.CAN_BO_QUAN_LY.XOA_QUANLYNHANUOC, { qlnn: qlnn });
    // }

    getListChuongTrinh(data): Observable<any> {
        return super.post(apiUrl.GDNN.CHUONG_TRINH.CHUONGTRINH_LIST, data);
    }

    getListTKChuongTrinh(nganhID): Observable<any> {
        return super.get(apiUrl.GDNN.CHUONG_TRINH.CHUONGTRINH_LIST_TIMKIEM, { nganhID: nganhID });
    }

    getDSChuongTrinhDaoTao(heDaoTaoID, nganhID): Observable<any> {
        return super.get(apiUrl.GDNN.CHUONG_TRINH.GET_DS_CHUONG_TRINH, { heDaoTaoID: heDaoTaoID, nganhID: nganhID });
    }

    getListChuongTrinhID(chuongTrinhID): Observable<any> {
        return super.get(apiUrl.GDNN.CHUONG_TRINH.CHUONGTRINH_LIST_ID, { chuongTrinhID: chuongTrinhID });
    }
    saoChepMon(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.CHUONG_TRINH.SAO_CHEP, requestBody);
    }

    addChuongTrinh(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.CHUONG_TRINH.THEM_CHUONGTRINHDAOTAO, requestBody);
    }

    updateChuongTrinh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.CHUONG_TRINH.SUA_CHUONGTRINHDAOTAO, requestBody);
    }

    deleteChuongTrinh(chuongTrinhID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.CHUONG_TRINH.XOA_CHUONGTRINH, { chuongTrinhDaoTaoID: chuongTrinhID, updatedBy: updatedBy });
    }

    getListMon(chuongTrinhID, tuHocKy, denHocKy): Observable<any> {
        return super.get(apiUrl.GDNN.CHUONG_TRINH.MON_LIST, { chuongTrinhID: chuongTrinhID, tuHocKy: tuHocKy, denHocKy: denHocKy });
    }

    exportXetTienDo(chuongTrinhID, tuHocKy, denHocKy): Observable<any> {
        return super.get(apiUrl.GDNN.CHUONG_TRINH.MON_LIST, { chuongTrinhID: chuongTrinhID, tuHocKy: tuHocKy, denHocKy: denHocKy });
    }

    getListMonTN(lopHocID): Observable<any> {
        return super.get(apiUrl.GDNN.XETTIENDO.MON_TOT_NGHIEP, { lopHocID: lopHocID });
    }

    updateCCTiengAnh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.MON_TOT_NGHIEP.UPDATE_CC_TIENGANH, requestBody);
    }

    updateCCTinHoc(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.MON_TOT_NGHIEP.UPDATE_CC_TINHOC, requestBody);
    }

    addMon(data): Observable<any> {
        return super.post(apiUrl.GDNN.CHUONG_TRINH.THEM_MON, data);
    }
    updateMon(data): Observable<any> {
        return super.put(apiUrl.GDNN.CHUONG_TRINH.SUA_MON, data);
    }

    deleteMon(monHocID, chuongTrinhID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.CHUONG_TRINH.XOA_MON, { monHocID: monHocID, chuongTrinhID: chuongTrinhID, updatedBy: updatedBy });
    }

    getListGiaoTrinh(data): Observable<any> {
        return super.get(apiUrl.GDNN.GIAO_TRINH.GIAOTRINH_LIST, data);
    }

    addGiaoTrinh(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.GIAO_TRINH.THEM_GIAOTRINH, requestBody);
    }

    deleteGiaoTrinh(giaoTrinhDaoTaoID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.GIAO_TRINH.XOA_GIAOTRINH, { giaoTrinhDaoTaoId: giaoTrinhDaoTaoID, updatedBy: updatedBy });
    }

    updateGiaoTrinh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.GIAO_TRINH.CAP_NHAT_GIAOTRINH, requestBody);
    }
    //Tuyển sinh

    getListSinhVien(data): Observable<any> {
        return super.post(apiUrl.GDNN.TUYEN_SINH.SINHVIEN_LIST, data);
    }
    getListSinhVienID(sinhVienID): Observable<any> {
        return super.get(apiUrl.GDNN.TUYEN_SINH.SINHVIEN_ID, { hocVienID: sinhVienID });
    }
    addSinhVien(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.TUYEN_SINH.SINHVIEN_THEM, requestBody);
    }
    updateSinhVien(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TUYEN_SINH.SINHVIEN_SUA, requestBody);
    }
    deleteSinhVien(hocVienID): Observable<any> {
        return super.delete(apiUrl.GDNN.TUYEN_SINH.SINHVIEN_XOA, { hocVienID: hocVienID });
    }
    //kỳ tuyển sinh
    getListKyTuyensinh(requestBody, page, size): Observable<any> {
        return super.post(apiUrl.GDNN.TUYEN_SINH.KYTUYENSINH_LIST + '?page=' + page + '&size=' + size, requestBody);
    }
    addKyTuyenSinh(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.TUYEN_SINH.KYTUYENSINH_THEM, requestBody);
    }
    updateKyTuyenSinh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TUYEN_SINH.KYTUYENSINH_SUA, requestBody);
    }
    deleteKyTuyenSinh(kyTuyenSinhID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.TUYEN_SINH.KYTUYENSINH_XOA, { kyTuyenSinhID: kyTuyenSinhID, updatedBy: updatedBy });
    }

    dongKyTuyenSinh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TUYEN_SINH.DONG_KYTUYENSINH, requestBody);
    }

    //tuyển sinh học bạ
    getListTuyenSinhHocBa(data): Observable<any> {
        return super.get(apiUrl.GDNN.TUYEN_SINH.TUYEN_SINH_HOC_BA_LIST, data);
    }
    getListXetTuyenTheoHocBa(kyTuyenSinhID, heDaoTaoID, page, size): Observable<any> {
        return super.get(apiUrl.GDNN.TUYEN_SINH.XET_TUYEN_THEO_HOC_BA_LIST, { kyTuyenSinhID: kyTuyenSinhID, heDaoTaoID: heDaoTaoID, page: page, size: size });
    }
    addTuyenSinhHocBa(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.TUYEN_SINH.TUYEN_SINH_HOC_BA_ADD, requestBody);
    }
    updateTuyenSinhHocBa(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TUYEN_SINH.TUYEN_SINH_HOC_BA_UPDATE, requestBody);
    }
    deleteTuyenSinhHocBa(hocVienID, kyTuyenSinhID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.TUYEN_SINH.TUYEN_SINH_HOC_BA_DELETE, { hocVienID: hocVienID, kyTuyenSinhID: kyTuyenSinhID, updatedBy: updatedBy });
    }
    //xét tuyển theo học bạ
    xetTuyenHocBa(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TUYEN_SINH.XET_TUYEN_HOC_BA, requestBody);
    }
    //tuyển sinh liên thông
    getListTuyenSinhLienThong(kyTuyenSinhID, page, size): Observable<any> {
        return super.get(apiUrl.GDNN.TUYEN_SINH.TUYEN_SINH_LIEN_THONG_LIST, { kyTuyenSinhID: kyTuyenSinhID, page: page, size: size });
    }
    xetTuyenLienThong(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TUYEN_SINH.XET_TUYEN_LIEN_THONG, requestBody);
    }
    getListXetTuyenLienThong(kyTuyenSinhID, page, size): Observable<any> {
        return super.get(apiUrl.GDNN.TUYEN_SINH.XET_TUYEN_LIEN_THONG_LIST, { kyTuyenSinhID: kyTuyenSinhID, page, size });
    }

    addTuyenSinhLienThong(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.TUYEN_SINH.TUYEN_SINH_LIEN_THONG_ADD, requestBody);
    }
    updateTuyenSinhLienThong(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TUYEN_SINH.TUYEN_SINH_LIEN_THONG_UPDATE, requestBody);
    }
    deleteTuyenSinhLienThong(hocVienID, kyTuyenSinhID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.TUYEN_SINH.TUYEN_SINH_LIEN_THONG_DELETE, { hocVienID: hocVienID, kyTuyenSinhID: kyTuyenSinhID, updatedBy: updatedBy });
    }

    //Công tác sinh viên
    ListTrungTuyen(kyTuyenSinhID, heDaoTaoID, loaiTrungTuyen, maTuyenSinh, page, size) {
        return super.get(apiUrl.GDNN.HOC_VIEN.LIST_TRUNG_TUYEN, { kyTuyenSinhID: kyTuyenSinhID, heDaoTaoID: heDaoTaoID, loaiTuyenSinh: loaiTrungTuyen, maTuyenSinh: maTuyenSinh, page: page, size: size });
    }
    boSungHoSo(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.HOC_VIEN.BO_SUNG_THONG_TIN, requestBody);
    }
    capNhatAnhHocVien(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.HOC_VIEN.CAP_NHAT_ANH, requestBody);
    }
    ListNhapHoc(heDaoTaoID, nganhID, loaiTuyenSinh, page, size) {
        return super.get(apiUrl.GDNN.HOC_VIEN.LIST_NHAP_HOC, { heDaoTaoID: heDaoTaoID, nganhID: nganhID, loaiTuyenSinh: loaiTuyenSinh, page: page, size: size });
    }
    phanBoLopHoc(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.HOC_VIEN.XEP_LOP, requestBody);
    }
    ListHocVienTheoLop(lopHocID) {
        return super.get(apiUrl.GDNN.HOC_VIEN.LIST_HOC_VIEN_THEO_LOP, { lopID: lopHocID });
    }

    thietLapLop(obj): Observable<any> {
        return super.put(apiUrl.GDNN.HOC_VIEN.thietLapLop, obj);
    }

    thayDoiMaHocVien(obj): Observable<any> {
        return super.put(apiUrl.GDNN.HOC_VIEN.thayDoiMaHocVien, obj);
    }

    getListNguoiThan(sinhVienID): Observable<any> {
        return super.get(apiUrl.GDNN.TUYEN_SINH.NGUOITHAN_LIST, { sinhVienID: sinhVienID });
    }
    addNguoiThan(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.TUYEN_SINH.NGUOITHAN_THEM, requestBody);
    }
    updateNguoiThan(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TUYEN_SINH.NGUOITHAN_SUA, requestBody);
    }
    deleteNguoiThan(nguoiThanID): Observable<any> {
        return super.delete(apiUrl.GDNN.TUYEN_SINH.NGUOITHAN_XOA, { nguoiThanID: nguoiThanID });
    }

    getListTuyenSinhID(hocVienID): Observable<any> {
        return super.get(apiUrl.GDNN.TUYEN_SINH.TUYENSINH_LIST_ID, { hocVienID: hocVienID });
    }

    addTuyenSinh(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.TUYEN_SINH.TUYENSINH_THEM, requestBody);
    }
    updateTuyenSinhID(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TUYEN_SINH.TUYENSINH_SUA, requestBody);
    }
    deleteTuyenSinhID(nguoiThanID): Observable<any> {
        return super.delete(apiUrl.GDNN.TUYEN_SINH.TUYENSINH_XOA, { nguoiThanID: nguoiThanID });
    }

    getListDiemDuTuyen(tuyenSinhID): Observable<any> {
        return super.get(apiUrl.GDNN.TUYEN_SINH.DIEMDUTUYEN_LIST, { tuyenSinhID: tuyenSinhID });
    }

    addDiemDuTuyen(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.TUYEN_SINH.DIEMDUTUYEN_THEM, requestBody);
    }
    updateDiemDuTuyen(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.TUYEN_SINH.DIEMDUTUYEN_SUA, requestBody);
    }
    deleteDiemDuTuyen(diemDuTuyenID): Observable<any> {
        return super.delete(apiUrl.GDNN.TUYEN_SINH.DIEMDUTUYEN_XOA, { diemDuTuyenID: diemDuTuyenID });
    }

    getListNganhTS(hocVienID): Observable<any> {
        return super.get(apiUrl.GDNN.TUYEN_SINH.NGANH_LIST_TS, { hocVienID: hocVienID });
    }
    addNganhTS(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.TUYEN_SINH.NGANH_THEM_TS, requestBody);
    }
    deleteNganhTS(hocVienID, nganhID): Observable<any> {
        return super.delete(apiUrl.GDNN.TUYEN_SINH.NGANH_DELETE_TS, { hocVienID: hocVienID, nganhID: nganhID });
    }
    //Xét tuyển
    getListXetTuyen(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.XETTUYEN.XETTUYEN_LIST, requestBody);
    }
    updateDanhRot(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.XETTUYEN.DANHROT_UPDATE, requestBody);
    }
    updateTrungTuyen(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.XETTUYEN.TRUNGTUYEN_UPDATE, requestBody);
    }
    updateXepLop(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.HOC_VIEN.XEP_LOP, requestBody);
    }
    updateKhongNhapHoc(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.HOC_VIEN.KHONG_NHAP_HOC, requestBody);
    }
    updateThayDoiLop(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.HOC_VIEN.THAY_DOI_LOP, requestBody);
    }
    getListTrungTuyen(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.XETTUYEN.TRUNGTUYEN_LIST, requestBody);
    }

    //Quản lý điểm
    lapListHocLai(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.LIST_HOC_LAI, requestBody);
    }

    getDiem(lopID, monHocID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.GET_DIEM, { lopHocID: lopID, monHocID: monHocID });
    }

    getThongKeDiem(lopID, monHocID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.GET_THONG_KE_DIEM, { lopID: lopID, monHocID: monHocID });
    }

    getTimKiemDiem(monHocID, lopHocID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.TIM_KIEM_DIEM_LAN_MOT, { lopHocID: lopHocID, monHocID: monHocID });
    }

    getListDiemHocLai(monHocID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.DIEM_HOC_LAI, { monHocID: monHocID });
    }

    listDangKyKTX(isDangKy, maHocVien, page, size): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.LIST_DK_KTX, { isDangKy: isDangKy, maHocVien: maHocVien, page: page, size: size });
    }

    dangKyKTX(data): Observable<any> {
        return super.post(apiUrl.GDNN.KTX.CREATE, data);
    }

    listDangOKTX(obj): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.listDangOKTX, obj);
    }

    updateDangKy(data): Observable<any> {
        return super.put(apiUrl.GDNN.KTX.UPDATE, data);
    }

    deleteDangKy(kyThucXaPhiID): Observable<any> {
        return super.delete(apiUrl.GDNN.KTX.DELETE, { kyThucXaPhiID: kyThucXaPhiID });
    }

    thanhToanPhiKTX(data): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.thanhToanPhiKTX, data);
    }

    addDiemThi(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.DIEM_UPDATE, requestBody);
    }

    addDiemThiLai(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.DIEM_THI_LAI_UPDATE, requestBody);
    }

    danhGia(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.DANH_GIA, requestBody);
    }

    getLapDanhSachThi(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.LAP_DANH_SACH_THI, requestBody);
    }

    addLichThi(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.ADD_LICH_THI, requestBody);
    }

    getLichThi(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.GET_LICH_THI, requestBody);
    }

    getListNghiemThu(requestBody): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.getListNghiemThu, requestBody);
    }

    getListCoiThi(requestBody): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.getListCoiThi, requestBody);
    }

    getListNghiemThuChamThi(requestBody): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.getListNghiemThuChamThi, requestBody);
    }

    addLopDuThi(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.addLopDuThi, requestBody);
    }

    getLopDuThi(): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.getLopDuThi);
    }

    getListDiemThiTheoMon(lopHocID, monHocID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.getListDiemThiTheoMonTheoLop, { monHocID: monHocID, lopHocID: lopHocID });
    }

    getListDuThi(lopHocID, monHocID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.LIST_DUTHI, { lopHocID: lopHocID, monHocID: monHocID });
    }



    xoaLopDuThi(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.xoaLopDuThi, requestBody);
    }

    xepLichThi(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.XEP_LICH_THI, requestBody);
    }

    getDanhSachDuThi(lichThiID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.DANH_SACH_DU_THI, { lichThiID: lichThiID });
    }

    deleteLichThi(lichThiID): Observable<any> {
        return super.delete(apiUrl.GDNN.DIEM.DELETE_LICHTHI, { lichThiID: lichThiID });
    }

    editLichThi(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.UPDATE_LICHTHI, requestBody);
    }

    getXepLichThi(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.GET_DANH_SACH_THI_TONG_QUAT, requestBody);
    }

    danhSoBaoDanh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.danhSoBaoDanh, requestBody);
    }

    danhPhachMaDe(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.danhPhachMaDe, requestBody);
    }

    diemThiTheoPhach1(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.diemThiTheoPhach1, requestBody);
    }

    diemThiTheoPhach2(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.diemThiTheoPhach2, requestBody);
    }

    diemThiTheoPhach3(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.diemThiTheoPhach3, requestBody);
    }

    listHocVienTheoLop(lichThiID, monHocID, lopHocID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.chamThi, { lichThiID: lichThiID, monHocID: monHocID, lopHocID: lopHocID });
    }

    getXacNhan(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.GET_XAC_NHAN, requestBody);
    }
    getDanhSachThi(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.GET_DANH_SACH_THI, requestBody);
    }
    getExportExcelDanhSachLop(lopHocID): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.DANH_SACH_LOP + "?lopID=" + lopHocID, "Danh sách học viên theo lớp");
    }
    //môn thi tốt nghiệp
    getListMonThiTN(nganhID, nienKhoaID, page, size): Observable<any> {
        return super.get(apiUrl.GDNN.MON_TOT_NGHIEP.GET_LIST, { nganhID: nganhID, nienKhoaID: nienKhoaID, page: page, size: size });
    }
    addMonThiTN(data): Observable<any> {
        return super.post(apiUrl.GDNN.MON_TOT_NGHIEP.CREATE, data);
    }
    updateMonThiTN(data): Observable<any> {
        return super.put(apiUrl.GDNN.MON_TOT_NGHIEP.UPDATE, data);
    }

    deleteMonThiTN(monTotNghiepID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.MON_TOT_NGHIEP.DELETE, { monTotNghiepID: monTotNghiepID, updatedBy: updatedBy });
    }

    phanBoMonTotNghiep(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.MON_TOT_NGHIEP.PHAN_BO_MON_TOT_NGHIEP, requestBody);
    }

    //Học phí
    thanhToan(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.THANHTOAN_HOCPHI, requestBody);
    }

    thanhToanTheoThang(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.thanhToanTheoThang, requestBody);
    }

    thanhToanVnptPay(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.THANHTOAN_VNPT_PAY, requestBody);
    }

    thanhToanHocPhiTheoLop(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.THANHTOAN_HOC_PHI_THEO_LOP, requestBody);
    }
    addHenNgay(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.HEN_NGAY, requestBody);
    }

    thanhToanKTX(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.KTX_PHI, requestBody);
    }

    getHocPhi(maSoSinhVien, hocKyID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.HOC_PHI, { hocVienID: maSoSinhVien, hocKyID: hocKyID });
    }

    getHocPhiTheoNganhThang(obj): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.getHocPhiTheoThang, obj);
    }

    getKetXuatHocPhiTheoKy(obj): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.ketXuatHocPhi, obj);
    }

    getHocPhiTheoThang(maSoSinhVien, hocKyID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.hocPhiTheoThang, { hocVienID: maSoSinhVien, hocKyID: hocKyID });
    }
    //excel tra cuu học phi
    getExportExcelTraCuuHocPhi(obj): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.exportExcelTraCuuHocPhi , "Kết quả tra cứu học viên", obj);
    }
    /**
    * @author psdung
    * @method POST
    * @param requestBody
    * @description Get PDF so ghi chep cau trang bia
    */

    info = JSON.parse(localStorage.getItem("user"));
    getHeaderDung() {
        let xTent;
        if(this.info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == this.info.maTruongGDNN)[0];
                xTent = nameXten.name;
        }
        if(!this.info.maTruongGDNN) {
            xTent = "demo";
        }

        if (xTent == "gdnnbte"){
            xTent = "bte";
        }
        const token = localStorage.getItem(AUTH.TOKEN_KEY);
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers = headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-Tenant', xTent)
        return headers;
    }

    getRequestOptions() {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: this.getHeaderDung()
        };
        return requestOptions;
    }

    getXuatHoaDonTheoKy(hocVienID, hocKyID): Observable<any> {
        let xTent;
        if(this.info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == this.info.maTruongGDNN)[0];
                xTent = nameXten.name;
        }
        if(!this.info.maTruongGDNN) {
            xTent = "demo";
        }

        if (xTent == "gdnnbte"){
            xTent = "bte";
        }
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'X-Tenant': xTent
            }),
            responseType: 'blob' as 'json',
        };

        return this.http.get(apiUrl.GDNN.DIEM.getTrangBiaHoaDon + "?hocVienID=" + hocVienID + "&hocKyID=" + hocKyID, requestOptions);
    }


    getXuatHoaDonTinChi(hocVienID, hocKyID): Observable<any> {
        let xTent;
        if(this.info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == this.info.maTruongGDNN)[0];
                xTent = nameXten.name;
        }
        if(!this.info.maTruongGDNN) {
            xTent = "demo";
        }

        if (xTent == "gdnnbte"){
            xTent = "bte";
        }
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'X-Tenant': xTent
            }),
            responseType: 'blob' as 'json',
        };

        return this.http.get(apiUrl.GDNN.DIEM.getHoaDonTheoTinChi + "?hocVienID=" + hocVienID + "&hocKyID=" + hocKyID, requestOptions);
    }

    getXuatHoaDonLePhi(ID): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.DIEM.getHoaDonLePhi + "?ID=" + ID , "Hóa đơn lệ phí");
    }

    getHocPhiTheoLop(lopHocID, hocKyID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.HOC_PHI_THEO_LOP, { lopHocID: lopHocID, hocKyID: hocKyID });
    }
    getThongKeLePhi(namTuyenSinh): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.THONG_KE_LE_PHI_THI, { namTuyenSinh: namTuyenSinh });
    }

    getThongTinCBHV(hocVienID, hocKyID, theoKy): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.THONG_TIN_CO_BAN_HOC_VIEN, { hocVienID: hocVienID, hocKyID: hocKyID, theoKy: theoKy });
    }

    getLePhiTheoHK(maSoSinhVien, hocKyID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.LE_PHI_THEO_HOC_KY, { maSoSinhVien: maSoSinhVien, hocKyID: hocKyID });
    }

    xepGiaoVienChamThi(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.xepGiaoVienChamThi, requestBody);
    }

    getHocVienID(coSoDaoTaoID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.GET_HOC_VIEN_ID, { coSoDaoTaoID: coSoDaoTaoID });
    }

    getMaHocVienID(coSoDaoTaoID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.GET_MA_HOC_VIEN_ID, { coSoDaoTaoID: coSoDaoTaoID });
    }

    suaLePhiKhac(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.suaLePhiKhac, requestBody);
    }

    getListDongLePhiKhac(obj): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.listLePhiKhac, obj);
    }

    themLePhiKhac(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.themLePhiKhac, requestBody);
    }

    xoaLePhiKhac(lePhiKhacID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DIEM.xoaLePhiKhac, { ID: lePhiKhacID, updatedBy: updatedBy });
    }

    //Phi dao tao theo nganh theo thang
    themHocPhiTheoThang(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.themHocPhiTheoThang, requestBody);
    }

    capNhatHocPhiTheoThang(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.capNhatHocPhiTheoThang, requestBody);
    }

    //excel le phi khac
    getExportExcelXetLePhiKhac(lePhiKhacID, ngayKetThuc, ngayBatDau, page, size): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.lePhiKhac + "?lePhiKhacID=" + lePhiKhacID +
            "&ngayKetThuc=" + ngayKetThuc + "&page=" + page + "&size=" + size + "&ngayBatDau=" + ngayBatDau, "Danh sách đóng tiền");
    }
    //xuat hoa đơn học phí
    getExportHoaDonHocPhi(kyTuyenSinhID, heDaoTaoID, page, size): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.xuatHoaDonHocPhi + "?kyTuyenSinhID=" + kyTuyenSinhID +
            "&heDaoTaoID=" + heDaoTaoID + "&page=" + page + "&size=" + size, "Hóa đơn học phí");
    }
    //xuat hoa đơn lệ phí
    getExportHoaDonLePhi(kyTuyenSinhID, heDaoTaoID, page, size): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.xuatHoaDonLePhi + "?kyTuyenSinhID=" + kyTuyenSinhID +
            "&heDaoTaoID=" + heDaoTaoID + "&page=" + page + "&size=" + size, "Hóa đơn học phí");
    }
    //Hoc bổng
    getListXetHocBong(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.HOC_BONG, requestBody);
    }
    //Điểm rèn luyện
    getDiemRenLuyen(lopHocID, nienKhoaID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.DIEM_REN_LUYEN, { lopHocID: lopHocID, nienKhoaID: nienKhoaID });
    }
    phanBoDiemRenLuyen(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.PHAN_BO_DIEM_REN_LUYEN, requestBody);
    }
    addDiemRenLuyen(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.UPDATE_DIEM_REN_LUYEN, requestBody);
    }
    addGhiChu(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.updateGhiChu, requestBody);
    }
    getListThangTheoHocKy(lopHocID, hocKyID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.THANG_THEO_HOC_KY, { lopHocID: lopHocID, hocKyID: hocKyID });
    }
    getListRenLuyenTheoHK(lopHocID, hocKyID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.LIST_REN_LUYEN_THEO_HK, { lopHocID: lopHocID, hocKyID: hocKyID });
    }
    //Xét tiến độ
    getListXetTienDo(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.XETTIENDO.XET_TIEN_DO_LIST, requestBody);
    }
    exportExcelXetTienDo(requestBody): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.XETTIENDO.EXPORT_XET_TIEN_DO, "XetTienDo", requestBody);
    }
    getListDuDieuKienDuThiTN(lopHocID): Observable<any> {
        return super.get(apiUrl.GDNN.XETTIENDO.DIEU_KIEN_DU_THI_TOT_NGHIEP, { lopHocID: lopHocID });
    }

    getListXetTotNghiep(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.XETTIENDO.XET_TOT_NGHIEP, requestBody);
    }
    //Danh mục
    //getListDanToc(data): Observable<any> {
    //   return super.post(apiUrl.GDNN.DANH_MUC.DANTOC_LIST, data);
    //}
    getListThongTu(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.THONGTU_LIST);
    }

    addThongTu(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.THONGTU_ADD, requestBody);
    }

    updateThongTu(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.THONGTU_EDIT, requestBody);
    }

    deleteThongTu(thongTuTuyenSinhID): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.THONGTU_DELETE, { thongTuTuyenSinhID: thongTuTuyenSinhID });
    }

    //Hoa don
    getListHoaDon(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.getListHoaDon);
    }

    addHoaDon(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.themHoaDon, requestBody);
    }

    updateHoaDon(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.capNhatHoaDon, requestBody);
    }

    deleteHoaDon(hoaDonID): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.xoaHoaDon, { hoaDonID: hoaDonID });
    }
    //End hoa don

    getListDanToc(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.DANTOC_LIST);
    }

    getSearchDanToc(tenDanToc): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.DANTOC_SEARCH, {danTocTen : tenDanToc});
    }

    //Le phi khac
    getListLePhiKhac(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.LEPHIKHAC_LIST);
    }

    addListLePhiKhac(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.LEPHIKHAC_ADD, requestBody);
    }

    updateLePhiKhac(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.LEPHIKHAC_EDIT, requestBody);
    }

    deleteLePhiKhac(thongTuTuyenSinhID, uuid): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.LEPHIKHAC_DELETE, { lePhiKhacID: thongTuTuyenSinhID, updatedBy: uuid });
    }
    //End le phi khac

    //Trinh độ giảng dạy
    getListTrinhDoGD(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.getListTrinhDoGD);
    }

    //End trình độ giảng dạy

    //Chức vụ cán bộ
    getListChucVuCB(isChucVuDoanThe): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.getListChucVuCB, { isChucVuDoanThe: isChucVuDoanThe });
    }
    //End chức vụ cán bộ

    //Ngach
    getListNgach(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.getListNgach);
    }

    addNgach(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.themNgach, requestBody);
    }

    updateNgach(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.capNhatNgach, requestBody);
    }

    deleteNgach(ngachID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.xoaNgach, { ngachID: ngachID, updatedBy: updatedBy });
    }
    //End ngach

    //getListchuyenMonNV
    getListChuyenMonNV(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.getListChuyenMonNV);
    }

    getSearchChuyenMonNV(tenChuyenMonNghiepVu): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.searchChuyenMonNV, {tenChuyenMonNghiepVu: tenChuyenMonNghiepVu});
    }
    //End chuyen mon nghiep vu



    addDanToc(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.DANTOC_ADD, requestBody);
    }

    updateDanToc(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.DANTOC_UPDATE, requestBody);
    }

    deleteDanToc(nationID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.DANTOC_DELETE, { danTocID: nationID, updatedBy: updatedBy });
    }

    getListTonGiao(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.TONGIAO_LIST);
    }

    getSearchTonGiao(tonGiaoTen): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.TONGIAO_SEARCH, {tonGiaoTen: tonGiaoTen});
    }

    addTonGiao(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.TONGIAO_ADD, requestBody);
    }

    updateTonGiao(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.TONGIAO_UPDATE, requestBody);
    }

    deleteTonGiao(religionID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.TONGIAO_DELETE, { tonGiaoID: religionID, updatedBy: updatedBy });
    }

    getListKhuVucTuyenSinh(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.KHUVUCTUYENSINH_LIST);
    }

    addKhuVucTuyenSinh(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.KHUVUCTUYENSINH_ADD, requestBody);
    }

    updateKhuVucTuyenSinh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.KHUVUCTUYENSINH_UPDATE, requestBody);
    }

    deleteKhuVucTuyenSinh(enrollmentAreaID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.KHUVUCTUYENSINH_DELETE, { khuVucTuyenSinhID: enrollmentAreaID, updatedBy: updatedBy });
    }

    getListDoiTuongTuyenSinh(doiTuongTuyenSinhTen): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.DOITUONGTUYENSINH_LIST, {doiTuongTuyenSinhTen: doiTuongTuyenSinhTen});
    }

    addDoiTuongTuyenSinh(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.DOITUONGTUYENSINH_ADD, requestBody);
    }

    editDoiTuongTuyenSinh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.DOITUONGTUYENSINH_UPDATE, requestBody);
    }

    deleteDoiTuongTuyenSinh(admissionSubjectID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.DOITUONGTUYENSINH_DELETE, { doiTuongTuyenSinhID: admissionSubjectID, updatedBy: updatedBy });
    }

    getListThanhPhanGiaDinh(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.THANHPHANGIADINH_LIST);
    }

    getSearchThanhPhanGiaDinh(thanhPhanGiaDinhTen): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.THANHPHANGIADINH_SEARCH, {thanhPhanGiaDinhTen: thanhPhanGiaDinhTen});
    }

    addThanhPhanGiaDinh(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.THANHPHANGIADINH_ADD, requestBody);
    }

    updateThanhPhanGiaDinh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.THANHPHANGIADINH_UPDATE, requestBody);
    }

    deleteThanhPhanGiaDinh(familyMemberID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.THANHPHANGIADINH_DELETE, { thanhPhanGiaDinhID: familyMemberID, updatedBy: updatedBy });
    }

    getListHinhThucDongHocPhi(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.HINHTHUCDONGHOCPHI_LIST);
    }

    addHinhThucDongHocPhi(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.HINHTHUCDONGHOCPHI_UPDATE, requestBody);
    }

    deleteHinhThucDongHocPhi(hinhThucDongHocPhiID): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.HINHTHUCDONGHOCPHI_DELETE, { hinhThucDongHocPhiID: hinhThucDongHocPhiID });
    }

    getListTienTinChi(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.TIENTINCHI_LIST);
    }

    addTienTinChi(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.TIENTINCHI_ADD, requestBody);
    }

    updateTienTinChi(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.TIENTINCHI_UPDATE, requestBody);
    }

    deleteTienTinChi(tienTinChiID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.TIENTINCHI_DELETE, { tienTinChiID: tienTinChiID, updatedBy: updatedBy });
    }

    getListHinhThucTuyenSinhs(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.HINHTHUCTUYENSINH_LIST);
    }

    addHinhThucTuyenSinh(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.HINHTHUCTUYENSINH_ADD, requestBody);
    }
    updateHinhThucTuyenSinh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.HINHTHUCTUYENSINH_UPDATE, requestBody);
    }

    deleteHinhThucTuyenSinh(hinhThucTuyenSinhID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.HINHTHUCTUYENSINH_DELETE, { hinhThucTuyenSinhID: hinhThucTuyenSinhID, updatedBy: updatedBy });
    }
    //
    getListKhoa(csdtID, khoaMaSo, khoaTen): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.KHOA, { coSoDaoTaoID: csdtID, khoaMaSo: khoaMaSo, khoaTen });
    }

    updateKhoa(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.KHOA_UPDATE, requestBody);
    }

    addKhoa(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.KHOA_ADD, requestBody);
    }

    deleteKhoa(khoaID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.kHOA_DELETE, { khoaID: khoaID, updatedBy: updatedBy });
    }
    //Ngành
    getListNganh(khoaID, heDaoTaoID): Observable<any> {
        if (khoaID != null) {
            return super.get(apiUrl.GDNN.DANH_MUC.NGANH_LIST, { khoaID: khoaID, heDaoTaoID: heDaoTaoID });
        } else {
            return super.get(apiUrl.GDNN.DANH_MUC.NGANH_LIST, { heDaoTaoID: heDaoTaoID });
        }
    }

    timKiemNganh(chuongTrinhID, tenNganh, kyHieuNganh): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.NGANH_TIM_KIEM, {
            chuongTrinhID: chuongTrinhID,
            tenNganh: tenNganh,
            kyHieuNganh: kyHieuNganh,
        });
    }

    addNganh(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.NGANH_ADD, requestBody);
    }

    updateNganh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.NGANH_UPDATE, requestBody);
    }

    deleteNganh(nganhID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.NGANH_DELETE, { nganhID: nganhID, updatedBy: updatedBy });
    }

    getListChinhSach(): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.CHINHSACH_LIST);
    }

    addChinhSach(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.CHINHSACH_ADD, requestBody);
    }

    updateChinhSach(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.CHINHSACH_UPDATE, requestBody);
    }

    deleteChinhSach(policyID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.CHINHSACH_DELETE, { dienChinhSachID: policyID, updatedBy: updatedBy });
    }

    getListHeDaoTao(bacDaoTao, heDaoTaoTen): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.HEDAOTAO_LIST, { bacDaoTao: bacDaoTao, heDaoTaoTen: heDaoTaoTen });
    }

    addHeDaoTao(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.HEDAOTAO_CREATE, requestBody);
    }

    editHeDaoTao(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.HEDAOTAO_UPDATE, requestBody);
    }

    deleteHeDaoTao(heDaoTaoID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.HEDAOTAO_DELETE, { heDaoTaoID: heDaoTaoID, updatedBy: updatedBy });
    }

    getListNienKhoa(requestParam): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.NIENKHOA_LIST, requestParam);
    }

    addNienKhoa(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.NIENKHOA_ADD, requestBody);
    }
    updateNienKhoa(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.NIENKHOA_UPDATE, requestBody);
    }

    deleteNienKhoa(nienKhoaID, uuid): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.NIENKHOA_DELETE, { nienKhoaId: nienKhoaID, updatedBy: uuid });
    }

    getListHinhThucDaoTao(hinhThucDaoTaoTen): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.HINHTHUCDAOTAO_LIST, {hinhThucDaoTaoTen: hinhThucDaoTaoTen});
    }
    addHinhThucDaoTao(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.HINHTHUCDAOTAO_ADD, requestBody);
    }

    editHinhThucDaoTao(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.HINHTHUCDAOTAO_UPDATE, requestBody);
    }

    deleteHinhThucDaoTao(hinhThucDaoTaoID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.HINHTHUCDAOTAO_DELETE, { hinhThucDaoTaoID: hinhThucDaoTaoID, updatedBy: updatedBy });
    }

    getListDoiTuongUuTien(doiTuongUuTienTen): Observable<any> {
        return super.get(apiUrl.GDNN.DANH_MUC.DOITUONGUUTIEN_LIST, {doiTuongUuTienTen: doiTuongUuTienTen});
    }

    addDoiTuongUuTien(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.DOITUONGUUTIEN_ADD, requestBody);
    }

    updateDoiTuongUuTien(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.DOITUONGUUTIEN_UPDATE, requestBody);
    }

    deleteDoiTuongUuTien(doiTuongUuTienID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.DOITUONGUUTIEN_DELETE, { doiTuongUuTienID: doiTuongUuTienID, updatedBy: updatedBy });
    }

    // getListNgheDaoTao(coSoDaoTaoID): Observable<any> {
    //     return super.get(apiUrl.GDNN.DANH_MUC.NGHEDAOTAO_LIST, { coSoDaoTaoID: coSoDaoTaoID });
    // }
    // addNgheDaoTao(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.DANH_MUC.NGHEDAOTAO_UPDATE, requestBody);
    // }

    // deleteNgheDaoTao(ngheDaoTaoID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.DANH_MUC.NGHEDAOTAO_DELETE, { ngheDaoTaoID: ngheDaoTaoID });
    // }

    // getListKyNangNghe(coSoDaoTaoID): Observable<any> {
    //     return super.get(apiUrl.GDNN.DANH_MUC.KYNANGNGHE_LIST, { coSoDaoTaoID: coSoDaoTaoID });
    // }

    // addKyNangNghe1(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.DANH_MUC.KYNANGNGHE_UPDATE, requestBody);
    // }

    // deleteKyNangNghe1(kyNangNgheID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.DANH_MUC.KYNANGNGHE_DELETE, { kyNangNgheID: kyNangNgheID });
    // }

    // getListKetQuaHocTap(coSoDaoTaoID): Observable<any> {
    //     return super.get(apiUrl.GDNN.DANH_MUC.KETQUAHOCTAP_LIST, { coSoDaoTaoID: coSoDaoTaoID });
    // }

    // addKetQuaHocTap(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.DANH_MUC.KETQUAHOCTAP_UPDATE, requestBody);
    // }

    // deleteKetQuaHocTap(ketQuaHocTapID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.DANH_MUC.KETQUAHOCTAP_DELETE, { kqhtID: ketQuaHocTapID });
    // }

    // getListChuyenNganhDaoTao(coSoDaoTaoID): Observable<any> {
    //     return super.get(apiUrl.GDNN.DANH_MUC.CHUYENNGANHDAOTAO_LIST, { coSoDaoTaoID: coSoDaoTaoID });
    // }

    // addChuyenNganhDaoTao(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.DANH_MUC.CHUYENNGANHDAOTAO_UPDATE, requestBody);
    // }

    // deleteChuyenNganhDaoTao(chuyenNganhDaoTaoID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.DANH_MUC.CHUYENNGANHDAOTAO_DELETE, { cndtID: chuyenNganhDaoTaoID });
    // }

    // getListNghiepVuSuPham(coSoDaoTaoID): Observable<any> {
    //     return super.get(apiUrl.GDNN.DANH_MUC.NGHIEPVUSUPHAM_LIST, { coSoDaoTaoID: coSoDaoTaoID });
    // }

    // addNghiepVuSuPham(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.DANH_MUC.NGHIEPVUSUPHAM_UPDATE, requestBody);
    // }

    // deleteNghiepVuSuPham(nghiepVuSuPhamID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.DANH_MUC.NGHIEPVUSUPHAM_DELETE, { nvspID: nghiepVuSuPhamID });
    // }

    // getListLyLuanChinhTri(coSoDaoTaoID): Observable<any> {
    //     return super.get(apiUrl.GDNN.DANH_MUC.LYLUANCHINHTRI_LIST, { coSoDaoTaoID: coSoDaoTaoID });
    // }

    // addLyLuanChinhTri(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.DANH_MUC.LYLUANCHINHTRI_UPDATE, requestBody);
    // }

    // deleteLyLuanChinhTri(lyLuanChinhTriID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.DANH_MUC.LYLUANCHINHTRI_DELETE, { llctID: lyLuanChinhTriID });
    // }

    // getListChucVu(): Observable<any> {
    //     return super.get(apiUrl.GDNN.DANH_MUC.CHUC_VU);
    // }

    // addChucVu(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.DANH_MUC.CHUC_VU, requestBody);
    // }

    // updateChucVu(id,requestBody): Observable<any> {
    //     return super.put(apiUrl.GDNN.DANH_MUC.CHUC_VU + "/" + id, requestBody);
    // }

    // deleteChucVu(chucVuID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.DANH_MUC.CHUC_VU + '/' + chucVuID);
    // }

    editChuyenMonNghiepVu(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.capNhatChuyenMonNV, requestBody);
    }

    addChuyenMonNghiepVu(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.themChuyenMonNV, requestBody);
    }

    deleteChuyenMonNghiepVu(chuyenMonNghiepVuID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.xoaChuyenMonNV, { chuyenMonNghiepVuID: chuyenMonNghiepVuID, updatedBy: updatedBy });
    }

    // getListHinhThucTuyenDung(coSoDaoTaoID): Observable<any> {
    //     return super.get(apiUrl.GDNN.DANH_MUC.HINHTHUCTUYENDUNG_LIST, { coSoDaoTaoID: coSoDaoTaoID });
    // }

    // addHinhThucTuyenDung(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.DANH_MUC.HINHTHUCTUYENDUNG_UPDATE, requestBody);
    // }

    // deleteHinhThucTuyenDung(hinhThucTuyenDungID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.DANH_MUC.HINHTHUCTUYENDUNG_DELETE, { hinhThucTuyenDungID: hinhThucTuyenDungID });
    // }

    // getListQuanLyNhaNuoc(coSoDaoTaoID): Observable<any> {
    //     return super.get(apiUrl.GDNN.DANH_MUC.QUANLYNHANUOC_LIST, { coSoDaoTaoID: coSoDaoTaoID });
    // }

    // addQuanLyNhaNuoc(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.DANH_MUC.QUANLYNHANUOC_UPDATE, requestBody);
    // }

    // deleteQuanLyNhaNuoc(quanLyNhaNuocID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.DANH_MUC.QUANLYNHANUOC_DELETE, { quanLyNhaNuocID: quanLyNhaNuocID });
    // }

    // getListHinhThucGiangDay(coSoDaoTaoID): Observable<any> {
    //     return super.get(apiUrl.GDNN.DANH_MUC.HINHTHUCGIANGDAY_LIST, { coSoDaoTaoID: coSoDaoTaoID });
    // }

    // addHinhThucGiangDay(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.DANH_MUC.HINHTHUCGIANGDAY_UPDATE, requestBody);
    // }

    // deleteHinhThucGiangDay(hinhThucGiangDayID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.DANH_MUC.HINHTHUCGIANGDAY_DELETE, { hinhThucGiangDayID: hinhThucGiangDayID });
    // }

    suaTrinhDoGiangDay(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.suaTrinhDoGiangDay, requestBody);
    }

    addTrinhDoGiangDay(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.themTrinhDoGiangDay, requestBody);
    }

    deleteTrinhDoGiangDay(trinhDoGiangDayID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.xoaTrinhDoGiangDay, { trinhDoGiangDayID: trinhDoGiangDayID, updatedBy: updatedBy });
    }

    // getListNgheNghiepGiangDay(coSoDaoTaoID): Observable<any> {
    //     return super.get(apiUrl.GDNN.DANH_MUC.NGHENGHIEPGIANGDAY_LIST, { coSoDaoTaoID: coSoDaoTaoID });
    // }

    // addNgheNghiepGiangDay(requestBody): Observable<any> {
    //     return super.post(apiUrl.GDNN.DANH_MUC.NGHENGHIEPGIANGDAY_UPDATE, requestBody);
    // }

    // deleteNgheNghiepGiangDay(ngheNghiepGiangDayID): Observable<any> {
    //     return super.delete(apiUrl.GDNN.DANH_MUC.NGHENGHIEPGIANGDAY_DELETE, { ngheNghiepGiangDayID: ngheNghiepGiangDayID });
    // }

    editChucVuCanBo(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DANH_MUC.capNhatChucVuCB, requestBody);
    }

    addChucVuCanBo(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DANH_MUC.themChucVuCB, requestBody);
    }

    deleteChucVuCanBo(chucVuCanBoID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.DANH_MUC.xoaChucVuCB, { chucVuID: chucVuCanBoID, updatedBy: updatedBy });
    }
    //end danh mục

    //phong ung dung
    getListPhongUngDung(csdtID): Observable<any> {
        return super.get(apiUrl.GDNN.CO_SO_VAT_CHAT.PHONG_UNG_DUNG_LIST, { coSoDaoTaoID: csdtID });
    }

    searchPhongUngDung(csdtID, tenPhongUngDung): Observable<any> {
        return super.get(apiUrl.GDNN.CO_SO_VAT_CHAT.PHONG_UNG_DUNG_LIST, { coSoDaoTaoID: csdtID, tenPhongUngDung: tenPhongUngDung });
    }

    addPhongUngDung(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.CO_SO_VAT_CHAT.PHONG_UNG_DUNG_ADD, requestBody);
    }

    editPhongUngDung(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.CO_SO_VAT_CHAT.PHONG_UNG_DUNG_EDIT, requestBody);
    }

    deletePhongUngDung(phongUngDungID): Observable<any> {
        return super.delete(apiUrl.GDNN.CO_SO_VAT_CHAT.PHONG_UNG_DUNG_DELETE, { phongUngDungID: phongUngDungID });
    }

    //quan ly diem
    getListDiem(sinhVienID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.DIEM_LIST, { sinhVienID: sinhVienID });
    }

    addDiem(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.DIEM_ADD, requestBody);
    }
    updateDiem(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.DIEM_UPDATE, requestBody);
    }
    deleteDiem(diemID): Observable<any> {
        return super.delete(apiUrl.GDNN.DIEM.DIEM_DELETE, { diemID: diemID });
    }
    getListMonHoc(data): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.MON_HOC_LIST, data);
    }
    //end quan ly diem
    //Excel lịch thi
    getExportExcelTongKetDiemThi(monHocID, lopHocID): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.xuatDiemThiTheoMonTheoLop + "?monHocID=" + monHocID +
            "&lopHocID=" + lopHocID, "Danh sách điểm thi kết thúc môn.xlsx");
    }

    getExportExcelLichThi(requestBody): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.LICH_THI, "Lịch thi", requestBody);
    }
    getExportExcelDuThi(lichThiID): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.DU_THI + "?lichThiID=" + lichThiID, "Dự thi");
    }
    //Excel old
    getExportExcelCTDT(nganhID, ketXuat): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.CHUONGTRINH_DAOTAO + "?nganhID=" + nganhID + "&kieuXuat=" + ketXuat, "Chương trình đào tạo");
    }
    //excel xet tuyen hoc ba
    getExportExcelXetTuyenHocBa(kyTuyenSinhID, heDaoTaoID, page, size, ngayXetTuyen, thongTuID): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.XET_TUYEN_HOC_BA + "?kyTuyenSinhID=" + kyTuyenSinhID +
            "&heDaoTaoID=" + heDaoTaoID + "&page=" + page + "&size=" + size + "&ngayXetTuyen=" + ngayXetTuyen + "&thongTuID=" + thongTuID, "Danh sách tuyển sinh học bạ");
    }
    //word xet tuyen hoc ba
    getExportWordXetTuyenHocBa(kyTuyenSinhID, heDaoTaoID, page, size): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.WORD.XET_TUYEN_HOC_BA + "?kyTuyenSinhID=" + kyTuyenSinhID +
            "&heDaoTaoID=" + heDaoTaoID + "&page=" + page + "&size=" + size, "Quyết định tuyển sinh học bạ.docx");
    }
    //excel trung tuyen hoc ba
    getExportExcelTrungTuyenHocBa(kyTuyenSinhID, heDaoTaoID, page, size, ngayXetTuyen, thongTuID): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.TRUNG_TUYEN_HOC_BA + "?kyTuyenSinhID=" + kyTuyenSinhID +
            "&heDaoTaoID=" + heDaoTaoID + "&page=" + page + "&size=" + size + "&ngayXetTuyen=" + ngayXetTuyen + "&thongTuID=" + thongTuID, "Danh sách trúng tuyển theo học bạ");
    }
    //excel xet tuyen lien thong
    getExportExcelXetTuyenLienThong(kyTuyenSinhID, ngayXetTuyen, page, size, thongTuID): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.XET_TUYEN_LIEN_THONG + "?kyTuyenSinhID=" + kyTuyenSinhID +
            "&ngayXetTuyen=" + ngayXetTuyen + "&page=" + page + "&size=" + size + "&thongTuID=" + thongTuID, "Danh sách tuyển sinh liên thông");
    }
    //excel coi thi
    getExportExcelCoiThi(ngayBatDau, ngayKetThuc): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.listCoiThi + "?ngayBatDau=" + ngayBatDau + "&ngayKetThuc=" + ngayKetThuc, "Danh sách giáo viên coi thi");
    }
    //excel nghiệm thu coi thi
    getExportExcelNghiemThu(ngayBatDau, ngayKetThuc, hocKyNamHoc): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.nghiemThu + "?ngayBatDau=" + ngayBatDau + "&ngayKetThuc=" + ngayKetThuc + "&hocKyNamHoc=" + hocKyNamHoc, "Danh sách nghiệm thu coi thi");
    }
    //excel nghiệm thu chấm thi
    getExportExcelNghiemThuChamThi(ngayBatDau, ngayKetThuc, hocKyNamHoc): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.nghiemThuChamThi + "?ngayBatDau=" + ngayBatDau + "&ngayKetThuc=" + ngayKetThuc + "&hocKyNamHoc=" + hocKyNamHoc, "Danh sách nghiệm thu chấm thi");
    }
    //word xet tuyen lien thong
    getExportWordXetTuyenLienThong(kyTuyenSinhID, page, size): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.WORD.XET_TUYEN_LIEN_THONG + "?kyTuyenSinhID=" + kyTuyenSinhID + "&page=" + page + "&size=" + size, "Quyết định tuyển sinh liên thông.docx");
    }
    //excel trung tuyen lien thong
    getExportExcelTrungTuyenLienThong(kyTuyenSinhID, ngayXetTuyen, page, size, thongTuID): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.TRUNG_TUYEN_LIEN_THONG + "?kyTuyenSinhID=" + kyTuyenSinhID +
            "&ngayXetTuyen=" + ngayXetTuyen + "&page=" + page + "&size=" + size + "&thongTuID=" + thongTuID, "Danh sách trúng tuyển liên thông");
    }

    getExportExcelCSVC(coSoDaoTaoID): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.COSO_VATCHAT, "Cơ sở vật chất", { coSoDaoTaoID: coSoDaoTaoID });
    }

    //excel điểm rèn luyện
    getExportExcelDiemRL(lopHocID, nienKhoaID, bacDaoTao): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.DIEM_REN_LUYEN + "?lopHocID=" + lopHocID +
            "&nienKhoaID=" + nienKhoaID + "&bacDaoTao=" + bacDaoTao, "Danh sách điểm rèn luyện");
    }

    //end excel
    //PDF
    getExportPDF(coSoDaoTaoID, kieuXuat): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.PDF_GDNN.COSO_VATCHAT + "?coSoDaoTaoID=" + coSoDaoTaoID + "&kieuXuat=" + kieuXuat, "Cơ sở vật chất");
    }
    //end PDF
    // getCourseList(facilityID): Observable<any> {
    //     return super.get(apiUrl.GDNN.SINH_VIEN_CAO_DANG.COURSE_LIST, { facilityID: facilityID });
    // }
    getExportPDFCTDT(nganhID, ketXuat): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.CHUONGTRINH_DAOTAO + "?nganhID=" + nganhID + "&kieuXuat=" + ketXuat, "Chương trình đào tạo");
    }

    // getJobList(courseID): Observable<any> {
    //     return super.get(apiUrl.GDNN.SINH_VIEN_CAO_DANG.JOB_LIST, { courseID: courseID });
    // }

    // getListStudent(data): Observable<any> {
    //     return super.post(apiUrl.GDNN.SINH_VIEN_CAO_DANG.STUDENT_LIST, data);
    // }

    // exportStudent(data, filename, type): Observable<any> {
    //     var url = type == 0 ? apiUrl.GDNN.SINH_VIEN_CAO_DANG.EXPORT_EXCEL_STUDENT : apiUrl.GDNN.SINH_VIEN_CAO_DANG.EXPORT_PDF_STUDENT;
    //     return super.downloadFile(url, filename, data);
    // }

    getListCSVC(coSoDaoTaoID, coSoVatChatTen): Observable<any> {
        return super.get(apiUrl.GDNN.CO_SO_VAT_CHAT.CSVC_LIST, { coSoDaoTaoID: coSoDaoTaoID, coSoVatChatTen: coSoVatChatTen });
    }

    deleteCSVC(coSoVatChatID, uuid_user): Observable<any> {
        return super.delete(apiUrl.GDNN.CO_SO_VAT_CHAT.CSVC_DELETE, { coSoVatChatID: coSoVatChatID, updatedBy: uuid_user });
    }

    updateCSVC(data): Observable<any> {
        return super.put(apiUrl.GDNN.CO_SO_VAT_CHAT.CSVC_UPDATE, data);
    }

    createCSVC(data): Observable<any> {
        return super.post(apiUrl.GDNN.CO_SO_VAT_CHAT.CSVC_CREATE, data);
    }

    getListTBDT(nganhID): Observable<any> {
        return super.get(apiUrl.GDNN.THIET_BI_DAO_TAO.TBDT_LIST, { nganhID: nganhID });
    }

    deleteTBDT(thietBiDaoTaoID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.THIET_BI_DAO_TAO.TBDT_DELETE, { thietBiDaoTaoID: thietBiDaoTaoID, updatedBy: updatedBy });
    }

    updateTBDT(data): Observable<any> {
        return super.put(apiUrl.GDNN.THIET_BI_DAO_TAO.TBDT_UPDATE, data);
    }

    addTBDT(data): Observable<any> {
        return super.post(apiUrl.GDNN.THIET_BI_DAO_TAO.TBDT_THEM, data);
    }

    // getDanhMucTbdtFull(): Observable<any> {
    //     return super.get(apiUrl.GDNN.THIET_BI_DAO_TAO.TBDT_DANH_MUC);
    // }

    getListSubject(tenMonHoc, loaiMonHoc, maMonHoc, page, size): Observable<any> {
        return super.get(apiUrl.GDNN.SUBJECT.SUBJECT_LIST, {
            tenMonHoc: tenMonHoc, loaiMonHoc: loaiMonHoc, maMonHoc: maMonHoc,
            page: page, size: size
        });
    }

    addSubject(data): Observable<any> {
        return super.post(apiUrl.GDNN.SUBJECT.SUBJECT_ADD, data);
    }

    updateSubject(data): Observable<any> {
        return super.put(apiUrl.GDNN.SUBJECT.SUBJECT_UPDATE, data);
    }

    deleteSubject(monID, uuid): Observable<any> {
        return super.delete(apiUrl.GDNN.SUBJECT.SUBJECT_DELETE, { monHocID: monID, updatedBy: uuid });
    }

    getListHocKy(hocKyTen, nienKhoaID): Observable<any> {
        return super.get(apiUrl.GDNN.HOC_KY.HOC_KY_LIST, { hocKyTen: hocKyTen, nienKhoaID: nienKhoaID });
    }
    getListHocKyKTX(hocVienID): Observable<any> {
        return super.get(apiUrl.GDNN.HOC_KY.HOC_KY_KTX, { hocVienID: hocVienID });
    }

    addHocKy(data): Observable<any> {
        return super.post(apiUrl.GDNN.HOC_KY.HOC_KY_ADD, data);
    }

    updateHocKy(data): Observable<any> {
        return super.put(apiUrl.GDNN.HOC_KY.HOC_KY_UPDATE, data);
    }

    deleteHocKy(hocKyID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.HOC_KY.HOC_KY_DELETE, { hocKyID: hocKyID, updatedBy: updatedBy });
    }

    getListCSDT(coSoDaoTaoTen): Observable<any> {
        return super.get(apiUrl.GDNN.CSDT.CSDT_LIST, {coSoDaoTaoTen: coSoDaoTaoTen});
    }
    addCSDT(data): Observable<any> {
        return super.post(apiUrl.GDNN.CSDT.CSDT_ADD, data);
    }
    updateCSDT(data): Observable<any> {
        return super.put(apiUrl.GDNN.CSDT.CSDT_UPDATE, data);
    }

    deleteCSDT(coSoDaoTaoID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.CSDT.CSDT_DELETE, { coSoDaoTaoID: coSoDaoTaoID, updatedBy: updatedBy });
    }

    getListTuyenSinh(data): Observable<any> {
        return super.post(apiUrl.GDNN.TUYEN_SINH.TUYEN_SINH_LIST, data);
    }

    updateTuyenSinh(data): Observable<any> {
        return super.put(apiUrl.GDNN.TUYEN_SINH.TUYEN_SINH_UPDATE, data);
    }

    deleteTuyenSinh(tuyenSinhID): Observable<any> {
        return super.delete(apiUrl.GDNN.TUYEN_SINH.TUYEN_SINH_DELETE, { tuyenSinhID: tuyenSinhID });
    }

    getListHinhThucTuyenSinh(): Observable<any> {
        return super.get(apiUrl.GDNN.TUYEN_SINH.HINH_THUC_TUYEN_SINH_LIST);
    }

    getSearchHinhThucTuyenSinh(hinhThucTuyenSinhTen): Observable<any> {
        return super.get(apiUrl.GDNN.TUYEN_SINH.HINH_THUC_TUYEN_SINH_SEARCH, {hinhThucTuyenSinhTen: hinhThucTuyenSinhTen});
    }

    //getListNganh(khoaID): Observable<any> {
    //    return super.get(apiUrl.GDNN.TUYEN_SINH.NGANH_LIST, { khoaID: khoaID });
    //}

    updateClass(data): Observable<any> {
        return super.put(apiUrl.GDNN.CLASS.CLASS_UPDATE, data);
    }

    createClass(data): Observable<any> {
        return super.post(apiUrl.GDNN.CLASS.CLASS_CREATE, data);
    }

    deleteClass(lopHocID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.CLASS.CLASS_DELETE, { lopHocID: lopHocID, updatedBy: updatedBy });
    }

    getListClass(nienKhoaID, lopKyHieu, page, pageSize): Observable<any> {
        if (lopKyHieu != null) {
            return super.get(apiUrl.GDNN.CLASS.CLASS_LIST, { nienKhoaID: nienKhoaID, lopKyHieu: lopKyHieu, page: page, pageSize: pageSize });
        }
        return super.get(apiUrl.GDNN.CLASS.CLASS_LIST, { nienKhoaID: nienKhoaID, page: page, size: pageSize });
    }

    updatePhong(data): Observable<any> {
        return super.put(apiUrl.GDNN.PHONG.PHONG_UPDATE, data);
    }

    createPhong(data): Observable<any> {
        return super.post(apiUrl.GDNN.PHONG.PHONG_CREATE, data);
    }

    deletePhong(phongID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.PHONG.PHONG_DELETE, { phongID: phongID, updatedBy: updatedBy });
    }

    getListPhong(data): Observable<any> {
        return super.get(apiUrl.GDNN.PHONG.PHONG_LIST, data);
    }

    getListDiemTongKet(lopID, hocKyID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.DIEM_TONG_KET_LIST, { lopID: lopID, hocKyID: hocKyID });
    }

    getHeader() {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers = headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        return headers;
    }

    // getKyTuyenSinh(page, pageSize, requestBody) {
    //     return this.http.get(apiUrl.GDNN.TUYEN_SINH.KYTUYENSINH_LIST + '?page=' + page + '&size=' + pageSize, requestBody,
    //     {
    //       headers: this.getHeader(),
    //     });
    // }
    // getListPhongUngDung(csdtID): Observable<any> {
    //     return super.get(apiUrl.GDNN.THIET_BI_DAO_TAO.PUD_LIST, {coSoDaoTaoID: csdtID});
    // }

    /**
     * @author ToiTV
     * @param lopKyHieu
     * @param coSoDaoTaoID
     * @returns Danh sách lớp học theo chương trình đào tạo
     */
    getTimKiemLop(lopKyHieu, coSoDaoTaoID): Observable<any> {
        return super.get(apiUrl.GDNN.XEP_MON.GET_LOP, { lopKyHieu: lopKyHieu, coSoDaoTaoID: coSoDaoTaoID });
    }

    /**
     * @author ToiTV
     * @param lopID
     * @returns Danh sách môn học theo học kỳ
     */
    getDanhSachMonHoc_HocKy(lopID): Observable<any> {
        return super.get(apiUrl.GDNN.XEP_MON.MON_HOC_KY, { lopID: lopID });
    }

    /**
     * @author ToiTV
     * @param lopID
     * @returns Danh sách học kỳ theo lớp
     */
    getDanhSachHocKyTheoLop(lopID): Observable<any> {
        return super.get(apiUrl.GDNN.XEP_MON.HOC_KY_THEO_LOP, { lopID: lopID });
    }

    /**
     * @author ToiTV
     * @param lopID
     * @returns Danh sách môn học theo lớp
     */
    getDanhSachMonTheoLop(lopID): Observable<any> {
        return super.get(apiUrl.GDNN.XEP_MON.MON_HOC_THEO_LOP, { lopID: lopID });
    }

    /**
     * @author ToiTV
     * @param data
     * @returns Thêm môn học cho học kỳ
     */
    postDanhSachMonHoc(data): Observable<any> {
        return super.post(apiUrl.GDNN.XEP_MON.LEN_DANH_SACH_MON_HOC, data);
    }

    /**
     * @author ToiTV
     * @param data
     * @returns Cập nhật môn học
     */
    putDanhSachMonHoc(data): Observable<any> {
        return super.put(apiUrl.GDNN.XEP_MON.CAP_NHAT_MON_HOC, data);
    }

    /**
     * @author ToiTV
     * @returns Danh sách giảng viên
     */
    getDanhSachGV(): Observable<any> {
        return super.get(apiUrl.GDNN.XEP_MON.CAN_BO_GIANG_VIEN, { page: 0, size: 100 });
    }

    /**
     * @author ToiTV
     * @returns Xóa môn học
     */
    deleteMonHoc(data): Observable<any> {
        return super.delete(apiUrl.GDNN.XEP_MON.XOA_MON, {
            lopHocID: data.lopHocID,
            monHocID: data.monHocID, canBoID: data.canBoID, hocKyID: data.hocKyID, updatedBy: data.updatedBy
        });
    }

    /**
     * @author ToiTV
     * @returns Thiết lập điểm - học phí cho lớp
     */
    putThietlap(data): Observable<any> {
        return super.put(apiUrl.GDNN.XEP_MON.THIET_LAP, data);
    }

    getListMonTotNghiep(lopHocID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.GET_LIST_MON_TOT_NGHIEP, { lopHocID: lopHocID });
    }

    getListNgayThiTotNghiep(lopHocID): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.GET_LIST_NGAY_TOT_NGHIEP, { lopHocID: lopHocID });
    }

    getListDiemTotNghiepTheoLop(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.DIEM.GET_LIST_DIEM_TOT_NGHIEP_THEO_LOP, requestBody);
    }

    updateDiemTotNghiepTheoLop(data): Observable<any> {
        return super.put(apiUrl.GDNN.DIEM.UPDATE_DIEM_TOT_NGHIEP_THEO_LOP, data);
    }

    updateModulesStatus(data): Observable<any> {
        return super.put(apiUrl.GDNN.VNPT_PAY.UPDATE_MODULES_STATUS, data);
    }

    getListRole(): Observable<any> {
        return super.get(apiUrl.GDNN.ROLE.LIST);
    }

    addRole(data): Observable<any> {
        return super.post(apiUrl.GDNN.ROLE.NEW, data);
    }

    updateRole(data): Observable<any> {
        return super.put(apiUrl.GDNN.ROLE.UPDATE, data);
    }

    deleteRole(roleID, updatedBy): Observable<any> {
        return super.delete(apiUrl.GDNN.ROLE.DELETE, { roleID: roleID, updatedBy: updatedBy });
    }


    //Tổng hợp

    getDanhSachTuyenSinh(tinhID, nam): Observable<any> {
        let requestOptions = {
            // responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': 'report'
            })
        };
        return this.http.get(apiUrl.GDNN.TONG_HOP.danhSachTuyenSinh + "?tinhID=" + tinhID + "&nam=" + nam, requestOptions);

        // return super.get(apiUrl.GDNN.BAOCAO.LIST_TUYEN_SINH, {tinhID: tinhID, nam: nam});
    }

    /**
      * @author psdung
      * @method GET
      * @param requestBody
      * @description Danh sách thiết bị
      */
    getDanhSachThietBi(tinhID, nam): Observable<any> {
        let requestOptions = {
            // responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': 'report'
            })
        };
        return this.http.get(apiUrl.GDNN.TONG_HOP.danhSachThietBi + "?tinhID=" + tinhID + "&nam=" + nam, requestOptions);
    }

    /**
      * @author psdung
      * @method GET
      * @param requestBody
      * @description Danh sách đào tạo nghề
      */
    getDanhSachDaoTaoNghe(tinhID, nam): Observable<any> {
        let requestOptions = {
            // responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': 'report'
            })
        };
        return this.http.get(apiUrl.GDNN.TONG_HOP.danhSachDaoTaoNghe + "?tinhID=" + tinhID + "&nam=" + nam, requestOptions);
    }

    /**
      * @author psdung
      * @method GET
      * @param requestBody
      * @description Danh sách tuyển sinh
      */
    getDanhSachCoSoDaoTao(tinhID, nam): Observable<any> {
        let requestOptions = {
            // responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': 'report'
            })
        };
        return this.http.get(apiUrl.GDNN.TONG_HOP.danhSachCoSoDaoTao + "?tinhID=" + tinhID + "&nam=" + nam, requestOptions);
    }

    /**
      * @author psdung
      * @method GET
      * @param requestBody
      * @description Danh sách tuyển sinh
      */
    getDanhSachBoiDuong(tinhID, nam): Observable<any> {
        let requestOptions = {
            // responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': 'report'
            })
        };
        return this.http.get(apiUrl.GDNN.TONG_HOP.danhSachBoiDuong + "?tinhID=" + tinhID + "&nam=" + nam, requestOptions);
    }

    luuDiemDanh(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.HOC_VIEN.LUU_DIEM_DANH, requestBody);
    }

    ListLichSuDiemDanh(lopHocID, monHocID, checkedDate, buoi) {
        return super.get(apiUrl.GDNN.HOC_VIEN.LICH_SU_DIEM_DANH, { lopHocID: lopHocID, monHocID: monHocID, checkedDate: checkedDate, buoi: buoi });
    }

    getLichSuDiemDanh(lopHocID, monHocID, checkedDate, buoi): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.PDF_GDNN.LICH_SU_DIEM_DANH + "?lopHocID=" + lopHocID + "&monHocID=" + monHocID + "&checkedDate=" + checkedDate + "&buoi=" + buoi, "Danh sách điểm danh");
    }

    capNhatDiemDanh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.HOC_VIEN.UPDATE_DIEM_DANH, requestBody);
    }

    //Bao cao gdnn
    xuatBaoCao201(maTinh, nam): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.HAILEMOT_GDNN_SO + "?maTinh=" + maTinh + "&nam=" + nam, "Báo cáo 201 / GDNN Sở");
    }

    getBaoCao201(maTinh, nam): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.HAILEMOT_GDNN_SO + "?maTinh=" + maTinh + "&nam=" + nam, requestOptions);
    }
    xuatBaoCaoCanBo(khoaID, phongID, maCanBo, page, size): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.REPORT_CANBO + "?khoaID=" + khoaID + "&phongID=" + phongID + "&maCanBo=" + maCanBo + "&page=" + page + "&size=" + size, "Báo cáo cán bộ, nhà giáo");
    }

    xuatBaoCao(canBoID): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.QUA_TRINH_CONG_TAC + "?canBoID=" + canBoID, "Quá trình công tác");

    }

    getListChinhSachTrongGDNN(obj): Observable<any> {
        return super.get(apiUrl.GDNN.CAN_BO_QUAN_LY.CHINH_SACH, obj);
    }

    addChinhSachTrongGDNN(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.CAN_BO_QUAN_LY.CHINH_SACH, requestBody);
    }

    deleteChinhSachTrongGDNN(id): Observable<any> {
        return super.delete(apiUrl.GDNN.CAN_BO_QUAN_LY.CHINH_SACH + "/" + id);
    }

    capNhatChinhSachTrongGDNN(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.CAN_BO_QUAN_LY.CHINH_SACH, requestBody);
    }
    
    xuatBaoCaoChuyenMon(canBoID): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.CHUYEN_MON + "?canBoID=" + canBoID, "Năng lực chuyên môn");

    }
    capGiayChungNhan(obj): Observable<any> {
        return super.post(apiUrl.GDNN.STG.capGiayChungNhan, obj);
    }


    getViewGiayChungNhan(obj): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.STG.getGiayChungNhan, "Giấy chứng nhận tốt nghiệp", obj);
    }

    getListCapGiay(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.STG.getListCapGiay, requestBody);
    }

    getExportExcel(requestBody): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.STG.exportExcel, "Danh sách cấp giấy chứng nhận", requestBody);
    }

    updateGiayChungNhan(data): Observable<any> {
        return super.put(apiUrl.GDNN.STG.updateGiayChungNhan, data);
    }

    deleteGiayChungNhan(data): Observable<any> {
        return super.put(apiUrl.GDNN.STG.deleteGiayChungNhan, data);
    }

    getLopBienChe(data): Observable<any> {
        return super.get(apiUrl.GDNN.CLASS.GET_LOP_BIEN_CHE, data);
    }

    getHocVienBienChe(idLopBienChe, page, size): Observable<any> {
        return super.get(apiUrl.GDNN.CLASS.HOC_VIEN_BIEN_CHE, { idLopBienChe: idLopBienChe, page: page, size: size });
    }

    updateLopBienChe(data): Observable<any> {
        return super.post(apiUrl.GDNN.CLASS.UPDATE_LOP_BIEN_CHE, data);
    }

    addLopBienChe(data): Observable<any> {
        return super.post(apiUrl.GDNN.CLASS.ADD_LOP_BIEN_CHE, data);
    }

    deleteLopBienChe(idLopBienChe): Observable<any> {
        return super.delete(apiUrl.GDNN.CLASS.DELETE_LOP_BIEN_CHE, { idLopBienChe: idLopBienChe });
    }

    addHocVienBienChe(data): Observable<any> {
        return super.post(apiUrl.GDNN.CLASS.ADD_HOC_VIEN_BIEN_CHE, data);
    }

    deleteHocVien(hocVienID): Observable<any> {
        return super.delete(apiUrl.GDNN.CLASS.DELETE_HOC_VIEN, { hocVienId: hocVienID });
    }

    deleteTatCaHocVien(idLopBienChe): Observable<any> {
        return super.delete(apiUrl.GDNN.CLASS.DELETE_TAT_CA_HOC_VIEN, { idLopBienChe: idLopBienChe });
    }

    mapSinhVien(cmnd): Observable<any> {
        return super.get(apiUrl.GDNN.HOC_VIEN.MAP_SINH_VIEN, { cmnd: cmnd });
    }

    getLopMonHoc(data): Observable<any> {
        return super.get(apiUrl.GDNN.CLASS.GET_LOP_MON_HOC, data);
    }

    getHocVienLopMonHoc(idLopMonHoc, page, size): Observable<any> {
        return super.get(apiUrl.GDNN.CLASS.DS_HOC_VIEN_LOP_MON_HOC, { idLopMonHoc: idLopMonHoc, page: page, size: size });
    }

    updateLopMonHoc(data): Observable<any> {
        return super.post(apiUrl.GDNN.CLASS.UPDATE_LOP_MON_HOC, data);
    }

    addLopMonHoc(data): Observable<any> {
        return super.post(apiUrl.GDNN.CLASS.ADD_LOP_MON_HOC, data);
    }

    deleteLopMonHoc(idLopMonHoc): Observable<any> {
        return super.delete(apiUrl.GDNN.CLASS.DELETE_LOP_MON_HOC, { idLopMonHoc: idLopMonHoc });
    }

    addHocVienLopMonHoc(data): Observable<any> {
        return super.post(apiUrl.GDNN.CLASS.ADD_HOC_VIEN_LOP_MON_HOC, data);
    }

    deleteHocVienLopMonHoc(hocVienID): Observable<any> {
        return super.delete(apiUrl.GDNN.CLASS.DELETE_HOC_VIEN_LOP_MON_HOC, { hocVienId: hocVienID });
    }

    deleteAllHocVienLopMonHoc(idLopMonHoc): Observable<any> {
        return super.delete(apiUrl.GDNN.CLASS.DELETE_ALL_HOC_VIEN_LOP_MON_HOC, { idLopMonHoc: idLopMonHoc });
    }

    //Hồ sơ xuất ngũ
    getListHoSoxuatNgu(obj): Observable<any> {
        return super.post(apiUrl.GDNN.HO_SO_XUAT_NGU.getListHoSoXuatNgu, obj );
    }

    getChiTietHoSoXuatNgu(uuid): Observable<any> {
        return super.get(apiUrl.GDNN.HO_SO_XUAT_NGU.getUuidHoSoXuatNgu, { uuid: uuid });
    }

    xoaHoSoXuatNgu(uuid, trangThaiXoa): Observable<any> {
        return super.delete(apiUrl.GDNN.HO_SO_XUAT_NGU.deleteHoSoXuatNgu, {uuid: uuid, trangThaiXoa: trangThaiXoa});
    }

    capNhatHoSoXuatNgu(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.HO_SO_XUAT_NGU.editHoSoXuatNgu, requestBody );
    }

    themMoiHoSoXuatNgu(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.HO_SO_XUAT_NGU.addHoSoXuatNgu, requestBody );
    }

    //Phan luong hoc sinh
    phanLuongHocSinh(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.HOC_VIEN.PHAN_LUONG_HOC_SINH, requestBody);
    }

    getChiTietPhanLuong(uuid): Observable<any> {
        return super.get(apiUrl.GDNN.HOC_VIEN.CHI_TIET_PHAN_LUONG, { uuid: uuid });
    }

    editPhanLuongHocSinh(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.HOC_VIEN.CAP_NHAT_PHAN_LUONG, requestBody);
    }

    XoaPhanLuong(uuid): Observable<any> {
        return super.delete(apiUrl.GDNN.HOC_VIEN.XOA_PHAN_LUONG, { uuid: uuid });
    }

    //BaoCao
    
    xuatBaoCaoThongTinDayNghe(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.thongTinDayNghe + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo thông tin dạy nghề");
    }
    listXtenant = XTENANT;
    getBCThongTinDayNghe(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }

        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.thongTinDayNghe + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoThongTinCanBo(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.thongTinCanBo + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo thông tin cán bộ");
    }

    getBCThongTinCanBo(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.thongTinCanBo + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoThongTinSinhVien(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.thongTinSinhVien + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo học sinh sinh viên");
    }

    getBCThongTinSinhVien(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.thongTinSinhVien + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoThongTinCoSo(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.coSoDayNghe + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo thông tin cơ sở giáo dục dạy nghề");
    }

    getBCThongTinCoSo(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.coSoDayNghe + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    //thiet bi muon chua tra
    xuatBaoCaoThietBiMuonChuaTra(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.thietBiMuonChuaTra + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo bảng kê thiết bị mượn quá hạn chưa trả");
    }

    getBaoCaoThietBiMuonChuaTra(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.thietBiMuonChuaTra + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    //bao cao thong ke hoc sinh co mat dau nam
    xuatBaoCaoHocSinhCoMatDauNam(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.sinhVienCoMayDauNam + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo học sinh, sinh viên học nghề có mặt đầu năm tại cơ sở");
    }

    getBaoCaoHocSinhCoMatDauNam(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.sinhVienCoMayDauNam + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoHocSinhTuyenMoiTrongNam(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.sinhVienTuyenMoi + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo học sinh, sinh viên tuyển mới trong năm tại cơ sở");
    }

    getBaoCaoHocSinhTuyenMoiTrongNam(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.sinhVienTuyenMoi + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    
    xuatBaoCaoHocSinhTuyenMoiSoCap(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.sinhVienTuyenMoiSoCap + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo học sinh tuyển mới trình độ sơ cấp");
    }

    getBaoCaoHocSinhTuyenMoiSoCap(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.sinhVienTuyenMoiSoCap + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoHocSinhTuyenMoiTrungCap(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.sinhVienTuyenMoiTrungCap + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo học sinh tuyển mới trình độ trung cấp");
    }

    getBaoCaoHocSinhTuyenMoiTrungCap(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.sinhVienTuyenMoiTrungCap + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoHocSinhTuyenMoiCaoDang(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.sinhVienTuyenMoiCaoDang + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo học sinh tuyển mới trình độ cao đẳng");
    }

    getBaoCaoHocSinhTuyenMoiCaoDang(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.sinhVienTuyenMoiCaoDang + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoHocSinhTheoDienChinhSach(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.sinhVienTuyenMoiTheoDienChinhSach + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo học sinh, sinh viên học nghề tuyển mới theo đối tượng chính sách");
    }

    getBaoCaoHocSinhTheoDienChinhSach(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.sinhVienTuyenMoiTheoDienChinhSach + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoHocSinhTotNghiep(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.sinhVienTotNghiep + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo học sinh, sinh viên tốt nghiệp trong năm tại cơ sở");
    }

    getBaoCaoHocSinhTotNghiep(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.sinhVienTotNghiep + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoHocSinhTotNghiepKhacNam(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.sinhVienTotNghiepKhacNam + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo học sinh, sinh viên tốt nghiệp khác năm tại cơ sở");
    }

    getBaoCaoHocSinhTotNghiepKhacNam(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.sinhVienTotNghiepKhacNam + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoHocSinhTotNghiepCaoDang(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.sinhVienTotNghiepCaoDang + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo thống kê học sinh sinh viên học nghề tốt nghiệp trình độ cao đẳng nghề tại cơ sở");
    }

    getBaoCaoHocSinhTotNghiepCaoDang(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.sinhVienTotNghiepCaoDang + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoHocSinhTotNghiepTrungCap(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.sinhVienTotNghiepTrungCap + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo thống kê học sinh sinh viên học nghề tốt nghiệp trình độ trung cấp nghề tại cơ sở");
    }

    getBaoCaoHocSinhTotNghiepTrungCap(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.sinhVienTotNghiepTrungCap + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoHocSinhTotNghiepSoCap(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.sinhVienTotNghiepSoCap + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo thống kê học sinh sinh viên học nghề tốt nghiệp trình độ sơ cấp và dưới 3 tháng tại cơ sở");
    }

    getBaoCaoHocSinhTotNghiepSoCap(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.sinhVienTotNghiepSoCap + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoHocSinhTotNghiepPhanA(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.sinhVienTotNghiepPhanA + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo thống kê học sinh sinh viên học nghề tốt nghiệp trong năm tại cơ sở theo ĐTCS Phần A");
    }

    getBaoCaoHocSinhTotNghiepPhanA(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.sinhVienTotNghiepPhanA + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }

    xuatBaoCaoHocSinhTotNghiepPhanB(maTinh, type): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.sinhVienTotNghiepPhanB + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, "Báo cáo thống kê học sinh sinh viên học nghề tốt nghiệp trong năm tại cơ sở theo ĐTCS Phần B");
    }

    getBaoCaoHocSinhTotNghiepPhanB(maTinh, type): Observable<any> {
        var info = JSON.parse(localStorage.getItem("user"));
        let xTent;
        if(info.maTruongGDNN){
            let nameXten = this.listXtenant.filter(x => x.value == info.maTruongGDNN )[0];
                xTent = nameXten.name;
        }
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
                'x-tenant': info.maTruongGDNN ? xTent : 'demo'
            })
        };
        return this.http.get(apiUrl.GDNN.BAOCAO.sinhVienTotNghiepPhanB + "?tinhID=" + maTinh + "&loaiBaoCao=" + type, requestOptions);
        
    }
    //quan lý in ấn cấp phát bằng
    getListBang(uuidHocVien): Observable<any> {
        return super.get(apiUrl.GDNN.CAP_PHAT_BANG.GET_LIST, {uuidHocVien: uuidHocVien});
    }

    addBang(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.CAP_PHAT_BANG.THEM, requestBody);
    }

    deleteBang(uuidVanBang): Observable<any> {
        return super.delete(apiUrl.GDNN.CAP_PHAT_BANG.XOA, { uuidVanBang: uuidVanBang });
    }

    updateBang(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.CAP_PHAT_BANG.CAP_NHAT, requestBody);
    }

    getChiTietBang(uuidVanBang): Observable<any> {
        return super.get(apiUrl.GDNN.CAP_PHAT_BANG.GET_CHI_TIET, {uuidVanBang: uuidVanBang});
    }

    xuatBaoCaoCapPhatBang(data): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.CAP_PHAT_BANG.EXPORT, "In ấn cấp phát bằng chứng chỉ", data);
    } 

    getXepLoaiTotNghiep(): Observable<any> {
        return super.get(apiUrl.GDNN.CAP_PHAT_BANG.xepLoaiTotNghiep);
    }

    //lien ket
    getListLienKet(data): Observable<any> {
        return super.get(apiUrl.GDNN.LIEN_KET_HOP_TAC.THEM_SUA_XOA, data);
    }

    addLienKet(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.LIEN_KET_HOP_TAC.THEM_SUA_XOA, requestBody);
    }

    deleteLienKet(uuid): Observable<any> {
        return super.delete(apiUrl.GDNN.LIEN_KET_HOP_TAC.THEM_SUA_XOA + "/" + uuid);
    }

    updateLienKet(requestBody): Observable<any> {
        return super.put(apiUrl.GDNN.LIEN_KET_HOP_TAC.THEM_SUA_XOA, requestBody);
    }

    getChiTietLienKet(uuid): Observable<any> {
        return super.get(apiUrl.GDNN.LIEN_KET_HOP_TAC.CHI_TIET + "/" + uuid);
    }

    deletePhiTheoNganh(nganhID, nienKhoaID, loaiTien, updatedBy): Observable<any> {
        return super.get(apiUrl.GDNN.DIEM.deletePhiTheoNganh, { nganhID: nganhID, nienKhoaID: nienKhoaID, loaiTien: loaiTien, updatedBy: updatedBy });
    }

    getExportExcelGiayBaoNhapHoc(hoTen, ngaySinh, diaChi): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.exportGiayBaoNhapHoc + "?hoTen=" + hoTen + "&ngaySinh=" + ngaySinh + "&diaChi=" + diaChi, "Giấy báo trúng tuyển.docx");
    }

    xuatDsDieuKienDuThi(lopHocID): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.exportDsXetDieuKienDuThi + "?lopHocID=" + lopHocID, "Danh sách xét điều kiện dự thi tốt nghiệp");
    }

    getLopMonHocPageable(data): Observable<any> {
        return super.get(apiUrl.GDNN.CLASS.DS_LOP_MON_HOC, data);
    }

    getLopBienChePageable(data): Observable<any> {
        return super.get(apiUrl.GDNN.CLASS.GET_LOP_BIEN_CHE, data);
    }

    getSinhVienSapLopMonHoc(data): Observable<any> {
        return super.get(apiUrl.GDNN.CLASS.DS_HOC_VIEN_SAP_LOP_MON_HOC, data);
    }

    sapLopMonHoc(data): Observable<any> {
        return super.post(apiUrl.GDNN.CLASS.SAP_LOP_MON_HOC, data);
    }

    getListNhomLopMonHoc(data): Observable<any> {
        return super.get(apiUrl.GDNN.CLASS.GET_LIST_NHOM_LOP_MON_HOC, data);
    }

    chiaNhomLopMonHoc(data): Observable<any> {
        return super.post(apiUrl.GDNN.CLASS.CHIA_NHOM_LOP_MON_HOC, data);
    }

    xoaNhomLopMonHoc(idLopMonHoc, nhomIDs: any[]): Observable<any> {
        return super.delete(apiUrl.GDNN.CLASS.DELETE_NHOM_LOP_MON_HOC, { idLopMonHoc: idLopMonHoc, nhomIDs: nhomIDs });
    }

    capNhatNhomLopMonHoc(data): Observable<any> {
        return super.put(apiUrl.GDNN.CLASS.UPDATE_NHOM_LOP_MON_HOC, data);
    }

    updateHocVienNhomLopMonHoc(data): Observable<any> {
        return super.put(apiUrl.GDNN.CLASS.UPDATE_HOC_VIEN_NHOM_LOP_MON_HOC, data);
    }

    getDsLopMonHocSoDauBai(data): Observable<any> {
        return super.get(apiUrl.GDNN.CLASS.DS_LOP_MON_HOC_SO_DAU_BAI, data);
    }

    getListNhomByIDs(data): Observable<any> {
        return super.get(apiUrl.GDNN.CLASS.GET_LIST_NHOM_BY_IDS, data);
    }

    getListGiaoVienLopMonHoc(obj): Observable<any> {
        return super.get(apiUrl.GDNN.CAN_BO_GIAO_VIEN.GIAO_VIEN_LOP_MON_HOC_LIST, obj);
    }

    // Sổ đầu bài
    getDsHocVienDiemDanh(data): Observable<any> {
        return super.get(apiUrl.GDNN.SO_DAU_BAI.GET_DS_HOC_VIEN_DIEM_DANH, data);
    }

    chiTietSoDauBai(data): Observable<any> {
        return super.get(apiUrl.GDNN.SO_DAU_BAI.CHI_TIET_SO_DAU_BAI, data);
    }

    kySoDauBai(data): Observable<any> {
        return super.post(apiUrl.GDNN.SO_DAU_BAI.KY_SO_DAU_BAI, data);
    }

    xuatDsHocVien(lopKyHieu, ngaySinh, maHocVien, tenHocVien): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.DS_HOC_VIEN + "?lopKyHieu=" + lopKyHieu + "&ngaySinh=" + ngaySinh + "&maHocVien=" + maHocVien + "&tenHocVien=" + tenHocVien, "Danh sách thông tin học viên");
    }

    getExportPhiTheoThang(nganhID, nienKhoaID, loaiTien): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.PDF_GDNN.PHI_DAO_TAO_THANG + "?nganhID=" + nganhID + "&nienKhoaID=" + nienKhoaID + "&loaiTien=" + loaiTien, loaiTien == true? "Danh sách đóng học phí theo tháng" : "Danh sách đóng học phí theo tín chỉ");
    }
    
    // Begin AGG
    getDataKQTS(obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'X-Tenant': 'so_ld'
            })
        };
        
        return this.http.get(apiUrl.GDNN.BAO_CAO_KQTS_AGG.SEARCH_BAO_CAO_KQTS + "?tenNganhNghe=" + obj.tenNganhNghe + "&thoiGian=" + obj.thoiGian + "&pageIndex=" + obj.pageIndex + "&pageSize=" + obj.pageSize, requestOptions);
        
    }

    importFileImportKQTS(obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'X-Tenant': 'so_ld'
            })
        };

        let api = apiUrl.GDNN.BAO_CAO_KQTS_AGG.IMPORT_BAO_CAO_KQTS;
        if(obj.thoiGian != null && obj.thoiGian != "null") {
            api += "?thoiGian=" + obj.thoiGian;
        }

        const formData = new FormData();
        formData.append("file", obj.file);
        return this.http.post(api, formData, requestOptions );
    }
    
    xuatFileImportSinhVien(): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.exportMauImportSinhVien, "File mẫu import sinh viên.xlsx");
    }

    uploadFileImportSinhVien(obj): Observable<any> {
        return super.post(apiUrl.GDNN.BAOCAO.ImportSinhVien + "?kyTuyenSinhID=" + obj.kyTuyenSinhID, obj);
    }


    xuatFileImportBoSung(kyTuyenSinhID, heDaoTaoID, loaiTrungTuyen, maTuyenSinh): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.BAOCAO.exportMauImportBoSung + "?kyTuyenSinhID=" + kyTuyenSinhID + "&heDaoTaoID=" + heDaoTaoID + "&loaiTuyenSinh=" + loaiTrungTuyen + "&maTuyenSinh=" + maTuyenSinh, "File mẫu import bổ sung sinh viên.xlsx");
    }

    uploadFileImportBoSung(requestBody): Observable<any> {
        return super.post(apiUrl.GDNN.BAOCAO.importBoSung, requestBody);
    }
    
    getExportExcelDangOKTX(ngayBatDau, ngayKetThuc, maHocVien): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.exportDangOKTX + "?ngayBatDau=" + ngayBatDau + "&ngayKetThuc=" + ngayKetThuc + "&maHocVien=" + maHocVien, "Danh sách thông tin phí ký túc xá");
    }

    getExportExcelDangKyKTX(lopKyHieu, ngaySinh, maHocVien, tenHocVien, dangKyKtx): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.exportDangOKTX + "?lopKyHieu=" + lopKyHieu + "&ngaySinh=" + ngaySinh + "&maHocVien=" + maHocVien + "&tenHocVien=" + tenHocVien + "&dangKyKtx=" + dangKyKtx, "Danh sách học viên đăng ký ký túc xá");
    }

    xuatFileImportCanBo(): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.exportImportCanBo, "File mẫu import cán bộ giáo viên.xlsx");
    }

    uploadFileImportCanBo(obj): Observable<any> {
        return super.post(apiUrl.GDNN.EXCEL.importCanBo, obj);
    }

    xuatFileImportDiemTheoMon(monHocID, lopHocID, chuongTrinhID): Observable<any> {
      return super.downloadFile(apiUrl.GDNN.DIEM.TEMPLATE_IMPORT_DIEM_TUNG_MON + "?monHocID=" + monHocID + "&lopHocID=" + lopHocID + "&chuongTrinhID=" + chuongTrinhID, "File mẫu import điểm theo môn.xlsx");
    }

    xuatExcelDiemTheoMon(monHocID, lopHocID): Observable<any> {
      return super.downloadFile(apiUrl.GDNN.DIEM.EXPORT_EXCEL_DIEM_TUNG_MON + "?monHocID=" + monHocID + "&lopHocID=" + lopHocID, "Danh sách điểm theo môn.xlsx");
    }

    importExcelDiemTheoMon(obj): Observable<any> {
      return super.post(apiUrl.GDNN.DIEM.IMPORT_EXCEL_DIEM_TUNG_MON, obj);
    }

    checkDataImportNhieuMon(obj): Observable<any> {
      return super.post(apiUrl.GDNN.DIEM.EXCEL_CHECK_DATA_IMPORT, obj);
    }

    exportExcelDSTrungTuyen(obj): Observable<any> {
      return super.downloadFile(apiUrl.GDNN.EXCEL.DANH_SACH_TRUNG_TUYEN, "Danh sách trúng tuyển", obj);
    }

    xuatFileImportMaSinhVien(lopID): Observable<any> {
        return super.downloadFile(apiUrl.GDNN.EXCEL.exportImportMaSinhVien + "?lopID=" + lopID, "File mẫu import mã sinh viên.xlsx");
    }

    uploadFileImportMaSinhVien(obj): Observable<any> {
        return super.post(apiUrl.GDNN.EXCEL.importMaSinhVien, obj);
    }
}
